import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ContactDashComponent, ContactDashConf, INavTab, defaultContactTabs } from 'contact-dash';
import { StarbaseModalOverlayService } from 'modal-overlay';
import { ITableColumn, NewTableEditorComponent, NewTableEditorUserViewOptions } from 'new-table-editor';
import { debounceTime, forkJoin, map, Observable, of, share, Subject, Subscription, takeUntil, filter } from 'rxjs';
import { LU_STContactType, LU_Grid, RateScheduleHeader, STContact, STContactEmail, STContactPhone, Job, DashConfSave, STLog, CustomerPaymentMethodEnum, Invoice, Site, LU_JobCode, LU_JobCategory, LU_MaterialSubCategory, Vehicle, LU_MaterialService, LU_VehicleType, LU_InvoiceBatch, ScaleTicketHeader, ScaleTicketStatusEnum, EODBatch, ScaleLinkService, InvoiceStatusEnum, Payment, CardType, LU_TermsModel, AutomatedAccount, PaymentSystemEnum, PaymentPendingService, NumberCommaDirective, LU_GridService, EmailMethodEnum, CustomerSelectComponent, VoucherSystemEnum, VoucherService, VoucherIdentificationTypeEnum, VoucherAccount, VoucherPaneMode, DLScannerService, SignatureService } from 'scaletech-core';
import { InvoiceDashComponent, InvoiceUpload, UploadStatusEnum } from 'scaletech-invoices';
import { JobDashComponent } from 'scaletech-jobs';
import { ScaleTicketHeaderDashComponent } from 'scaletech-tickets';
import { VehicleDashComponent } from 'scaletech-vehicles';
import { KioskDashComponent, KioskService } from "scaletech-kiosk";
import { StatusDashComponent, StatusServService } from 'scaletech-status';
import { PaymentDashComponent, PaymentService, EodDashComponent, EODBatchService, ForteService } from 'scaletech-payment';
import { ContactModel, FilterParams, ICommType, IEditCheck, IMessage, IUserAccountModel, LU_ContactType, removeDuplicateItems, StarbaseComponentMessage, StarbaseDataService, StarbaseDataServiceWithRequisites, StarbaseEntity, toggleObjInArray, TruncateString, UserAccountModel, UserGroupModel } from 'starbase-launcher';
import { IUserTokenModel, StarbaseLoginService } from 'starbase-login';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { IStarbaseNotificationObject, StarbaseNotificationObject, StarbaseNotificationSentiment, StarbaseNotificationService, StarbaseNotificationTypes } from 'starbase-notification';
import { CreateContactWizardComponent, StarbaseWizardStep } from 'starbase-wizard';
import { ContactEmailService } from '../services/contact-email.service';
import { ContactPhonesService } from '../services/contact-phone.service';
import { JobDataService } from '../services/job-data.service';
import { LogDataService } from '../services/log-data.service';
import { STContactDataService } from '../services/st-contact-data.service';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { UserDataService } from '../services/user-data.service';
import { LU_JobCodeService } from '../services/lookups/lu-job-code.service';
import { LU_JobCategoryService } from '../services/lookups/lu-job-category.service';
import { ScaleTicketHeaderDataService } from '../services/scale-ticket-header-data.service';
import { InvoiceDataService } from '../services/invoice-data.service';
import { LU_InvoiceBatchService } from '../services/lookups/lu-invoice-batch.service';
import { RateScheduleDataService } from '../services/rate-schedule-data.service';
import { SiteDataService } from '../services/site-data.service';
import { VehicleDataService } from '../services/vehicle-data.service';
import { LU_VehicleTypeService } from '../services/lookups/lu-vehicle-type.service';
import { AppGlobalsService } from '../services/app-globals.service';
import { AppComponent } from '../app.component';
import { DashConf, DashModuleBase, DashModuleColumnConf } from 'starbase-dashboard';
import { PasswordScoreEnum } from 'account-management';
import { DatePipe, DecimalPipe } from '@angular/common';
import { StarbaseServiceProviderService } from '../services/starbase-service-provider.service';
import { LU_MaterialServiceService } from '../services/lookups/lu-material-service.service';
import { ScaleTicketDetailDataService } from '../services/scale-ticket-detail-data.service';
import { ManifestFilesService } from '../services/manifest-files.service';
import { LU_MaterialSubCategoryService } from '../services/lookups/lu-material-sub-category.service';
import { LU_TermService } from '../services/lookups/lu-term.service';
import { WebSocketService } from '../services/web-socket.service';
import { environment } from '../../environments/environment';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { PaymentWizardComponent } from 'scaletech-wizards';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LocationModel } from 'scaletech-core';

export interface IDashTheme {
  name: string;
  class: string;
  color: string;
  secondaryColor?: string;
}

export interface InvoicePaymentModel {
  invoice: Invoice;
  payment: Payment;
}

export interface CreateInvoicePaymentResponseModel {
  invoiceUID: number;
  invoiceNumber: number;
  paymentUID: number;
  paymentNumber: number;
}

class DashPaneHandle<T extends StarbaseEntity> {
  private static _currentlyOpenPane = '';

  private readonly name: string;
  private paneOpen = false;
  singlePaneData: T;
  dataService: StarbaseDataService<T> | StarbaseDataServiceWithRequisites<T>;
  readonly adminSession: boolean;
  accentColor: string;
  paneWidth?: string;
  fullScreenMode?: boolean;
  addMode = false;
  editMode = false;
  specialMode = false;

  constructor(name: string,
    dataSvc: StarbaseDataService<T> | StarbaseDataServiceWithRequisites<T>,
    admin = false,
    accentColor = '#333') {
    this.name = name;
    this.singlePaneData = undefined;
    this.dataService = dataSvc;
    this.adminSession = admin;
    this.accentColor = accentColor;
    this.paneWidth = '900px';
    this.fullScreenMode = false;
  }
  public static get CurrentlyOpenPane() { return this._currentlyOpenPane; }

  public get HandleName(): string { return this.name; }
  public get HandleType() { return typeof (this.singlePaneData); }

  public openPane(paneObj?: T): void {
    this.singlePaneData = paneObj || this.singlePaneData;
    DashPaneHandle._currentlyOpenPane = this.name;
    this.paneOpen = true;
  }
  public closePane(): void {
    this.paneOpen = false;
    DashPaneHandle._currentlyOpenPane = '';
  }
  public get isPaneOpen(): boolean {
    return DashPaneHandle.CurrentlyOpenPane === this.name;
  }
  public toggleFullScreen(set?: boolean): void {
    this.fullScreenMode = set || !this.fullScreenMode;
  }

}

export class TimeZone {
  name: string;
  offset: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  DSToffset: string;
}
export function UsTimezones(): TimeZone[] {
  return [
    {
      name: 'America/Anchorage',
      offset: '-0900',
      DSToffset: '-0800'
    },
    {
      name: 'America/Chicago',
      offset: '-0600',
      DSToffset: '-0500'
    },
    {
      name: 'America/Denver',
      offset: '-0700',
      DSToffset: '-0600'
    },
    {
      name: 'America/Los_Angeles',
      offset: '-0800',
      DSToffset: '-0700'
    },
    {
      name: 'America/New_York',
      offset: '-0500',
      DSToffset: '-0400'
    },
    {
      name: 'America/Phoenix',
      offset: '-0700',
      DSToffset: '-0700'
    },
    {
      name: 'Pacific/Honolulu',
      offset: '-1000',
      DSToffset: '-1000'
    },
    {
      name: 'Coordinated Universal Time (UTC)',
      offset: 'UTC',
      DSToffset: 'UTC'
    }
  ];
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [
    trigger(
      'dashPaneSlide',
      [
        state('true', style({ right: 0, top: 20, backgroundColor: 'red', position: 'absolute' })),
        transition(':enter', [
          style({
            backgroundColor: 'green',
            right: -100,
            top: 20,
            position: 'absolute'
          }),
          animate(500)
        ]),
        transition(':leave', [
          animate(500,
            style({
              right: -100,
              top: 20,
              backgroundColor: 'yellow',
              position: 'absolute'
            }))
        ])
      ])
  ],
  standalone: false
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit, IEditCheck {

  displayName: string;
  public rateHeader: RateScheduleHeader = null;

  public contactData = [];

  public jobDashModule = new JobDashComponent(this.cd, this.jobDashSvc, this.siteSvc, this.sbSvcProvider, this.appGlobals);
  public sthDashModule = new ScaleTicketHeaderDashComponent(this.sthSvc, this.siteSvc, this.gridSvc, this.sbSvcProvider, this.contactEmailSvc, this.appGlobals, this.cd);
  public vehicleDashModule = new VehicleDashComponent(this.vehicleSvc, this.sbSvcProvider, this.siteSvc, this.appGlobals, this.cd);
  public invoiceDashModule = new InvoiceDashComponent(this.cd, this.invoiceSvc, this.sthSvc, this.siteSvc, this.contactEmailSvc, this.sbSvcProvider, this.appGlobals);
  public contactDashModule = new ContactDashComponent(this.cd);
  public statusDashModule = new StatusDashComponent(this.appGlobals, this.sbSvcProvider, this.cd);
  public kioskDashModule = new KioskDashComponent(this.appGlobals, this.sbSvcProvider, this.siteSvc, this.cd, this.kioskSvc, this.sthSvc);
  public paymentDashModule = new PaymentDashComponent(this.paymentSvc, this.invoiceSvc, this.siteSvc, this.appGlobals, this.sbSvcProvider, this.dp, this.cd);
  public eodDashModule = new EodDashComponent(this.eodBatchSvc, this.siteSvc, this.appGlobals, this.sbSvcProvider, this.dp, this.cd);

  jobPaneHandle = new DashPaneHandle('jobPane', this.jobDashSvc, this.isAdmin(), this.jobDashModule.boxMainColor);
  // eslint-disable-next-line max-len
  contactPaneHandle = new DashPaneHandle('contactPane', this.contactDashSvc, this.isAdmin(), this.contactDashModule.boxMainColor);
  vehiclePaneHandle = new DashPaneHandle('vehiclePane', this.vehicleSvc, this.isAdmin(), this.vehicleDashModule.boxMainColor);
  kioskPaneHandle = new DashPaneHandle('kioskPane', this.kioskSvc, this.isAdmin(), this.kioskDashModule.boxMainColor);
  scaleTicketPaneHandle = new DashPaneHandle('scaleTicketPane', this.sthSvc, this.isAdmin(), this.sthDashModule.boxMainColor);
  paymentPaneHandle = new DashPaneHandle('paymentPane', this.paymentSvc, this.isAdmin(), this.paymentDashModule.boxMainColor);

  toggleObjectInArray = toggleObjInArray;

  @ViewChild('defaultQuickActions', { static: true }) qatemplate: TemplateRef<any>;
  @ViewChild('dashOptionsModal', { static: true }) dashModalTemplate: TemplateRef<any>;
  @ViewChild('dashScaleOptionsModal', { static: true }) dashScaleOptionsTemplate: TemplateRef<any>;
  @ViewChild('newContactModal', { static: true }) newContactModalTemplate: TemplateRef<any>;
  @ViewChild('editUserModal', { static: true }) editUserModalTemplate: TemplateRef<any>;
  @ViewChild('contactPhonesTable') contactPhonesTable: NewTableEditorComponent<any>;
  @ViewChild('contactEmailsTable') contactEmailsTable: NewTableEditorComponent<any>;
  @ViewChild('pawneeCustomPane') pawneeCustomPane: TemplateRef<any>;
  @ViewChild('uidCol', { static: true }) uidCol: TemplateRef<any>;
  @ViewChild('endCols', { static: true }) endCols: TemplateRef<any>;
  @ViewChild('contactWizard') createContactWizard: CreateContactWizardComponent<STContact>;
  @ViewChild('customerStep', { static: true }) customerStep: TemplateRef<any>;
  @ViewChild('ctAssignModal', { static: true }) ctAssignModal: TemplateRef<any>;
  @ViewChild('sendEmailModal', { static: true }) sendEmailModal: TemplateRef<any>;
  @ViewChild('paymentInfoModal', { static: true }) paymentInfoModal: TemplateRef<any>;
  @ViewChild('textForEmail') textForEmail: ElementRef;
  @ViewChild('subjectForEmail') subjectForEmail: ElementRef;
  @ViewChild('customerSelect') customerSelect: CustomerSelectComponent;
  @ViewChild('paymentWizardComponentRef') paymentWizardRef: PaymentWizardComponent;
  @ViewChild('contactDashTemplate1Override', { static: true }) contactDashTemplate1Override: TemplateRef<any>;
  @ViewChild('contactVoucherTab') contactVoucherTab: TemplateRef<any>;

  contactPhoneCols: ITableColumn[] = STContactPhone.ContactPhoneColumns();
  contactEmailCols: ITableColumn[] = STContactEmail.ContactEmailColumns();
  emailViewOptsID = 'contactEmail';
  phoneViewOptsID = 'contactPhone';
  contactEmailTableViewOpts = new NewTableEditorUserViewOptions(true, false, false);
  contactPhoneTableViewOpts = new NewTableEditorUserViewOptions(true, false, false);
  contactPaneTabs: INavTab[];
  public editUserId: number;
  public promoteContact: STContact = null;
  managingContact = false;
  userGroups: UserGroupModel[];
  public createContactUserMode = false;
  public createContactWithUserWizOpen = false;
  public createContactWizOpen = false;
  public createScaleTicketWizOpen = false;
  // public createKioskAccountWizOpen = false;
  public scaleticketPreScreenOpen = false;
  public reportPreScreenOpen = false;
  public createInvoiceWizOpen = false;
  public createInvoiceBatchWizOpen = false;
  public createPaymentWizOpen = false;
  public createEODWizOpen = false;
  public copyRateWizOpen = false;
  public batchUploaderOpen = false;
  public isDownloading = false;
  public isGenerating = false;
  public serialSettingsOperationActive = false;
  public stMode = false;
  public invMode = false;
  public hideACHPaymentOption = false;
  public prepayMode = false;
  public errorSendingPayment = false;
  ticket: ScaleTicketHeader = null;
  ticketEdit = false;
  invoice: Invoice = null;
  job: Job = null;
  payment: Payment = null;
  paymentTicketNumbers: string = null;
  standardContactWizSteps: StarbaseWizardStep<STContact>[] = [];
  isCustomerWizSteps: StarbaseWizardStep<STContact>[] = [];
  addDefaultJob = false;
  customerDefaultJob: Job;
  invoiceUploadBatch: InvoiceUpload[];
  invoiceBatch: LU_InvoiceBatch;
  manifestLengthOverride: number;
  cloverAppMarketUrl: string;
  isCustStatement: boolean = false;
  prescreenMemo: boolean = false;

  vehicleToAddToContractAcc: Vehicle | null = null;

  preLoadContactTypes: LU_STContactType[] = [];
  materialsAndServices: LU_MaterialService[] = [];
  vehicleTypes: LU_VehicleType[] = [];
  sites: Site[] = [];
  customers: STContact[] = [];
  activeCustomers: STContact[] = [];
  jobs: Job[] = [];
  jobCodes: LU_JobCode[] = [];
  jobCategories: LU_JobCategory[] = [];
  invoices: Invoice[] = [];
  grids: LU_Grid[] = [];
  matSubCats: LU_MaterialSubCategory[] = [];
  vehicles: Vehicle[] = [];
  invoiceBatches: LU_InvoiceBatch[] = [];
  payments: Payment[] = [];
  terms: LU_TermsModel[];
  activeTerms: LU_TermsModel[];
  date = new Date;
  filterDateFrom: Date = null;
  filterDateTo: Date = null;
  customerStatementModalOpen: boolean = false;
  customerHistoryModalOpen: boolean = false;
  statmentID: number;
  selectedEmails: any[];
  emailSelectOpen: boolean = false;
  contactForStatement: STContact;

  private dateCustomClasses = [
    { date: this.date, classes: ['bg-info'] }
  ];
  paymentForRetry: Payment = null;
  emailLoaded = false;
  phoneLoaded = false;
  loadingRequisiteData = false;

  vouchersEnabled = false;
  voucherPaneOpen = false;
  voucherPaneEditMode = VoucherPaneMode.DashboardView;
  voucherPaneEditWithContact: STContact = null;
  voucherPaneEditWithVoucher: VoucherAccount = null;

  bsConfig: Partial<BsDatepickerConfig> = {
    isAnimated: true,
    adaptivePosition: true,
    containerClass: 'theme-green',
    showPreviousMonth: true,
    showWeekNumbers: false,
    ranges: [
      {
        value: [new Date(new Date().setHours(0, 0, 0, 0)), new Date()],
        label: 'Today'
      },
      {
        // eslint-disable-next-line max-len
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)), new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0))],
        label: 'Yesterday'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 7 Days'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth() - 6, 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 6 Months'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth(), 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Month To Date'
      },
      {
        value: [new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0), new Date()],
        label: 'Year To Date'
      }
    ],
    dateCustomClasses: this.dateCustomClasses
  };

  currentUser: IUserTokenModel = null;
  currentLoggedInUser: IUserAccountModel;
  currentLoggedInContact: ContactModel;
  currentQuickActionsContact: ContactModel;
  loadingQuickActionsContact = false;

  jobList$: Observable<Job[]>;
  contactList$: Observable<ContactModel[]>;

  userTimeZone: TimeZone;
  tooltipDelay = 500;

  sendingEmailTo: ContactModel;
  sendingEmailAddress: string;

  CUSTOMER_BADGE_VALUE = 'customer';
  booted = false; // are the dash modules booted up?

  jobsWatcherSubscription: Subscription;
  contactsWatcherSubscription: Subscription;
  createContactWithUserSubscription: Subscription;
  contactExcelExportSubscription: Subscription;
  loadContactsWatcherSubscription: Subscription;
  manageUserSubscription: Subscription;
  dashboardCustomizationsModalListener: Subscription;
  paymentWizardTicketModalListener: Subscription;
  paymentWizardTicketInvoiceModalListener: Subscription;
  paymentWizardInvoiceModalListener: Subscription;
  sbCmpMsgNotifySubscription: Subscription;
  sbCmpCmdSubscription: Subscription;
  selectedContactUID = 0;
  selectedJobUid = 0;
  viewRateSchedules = false;
  overrideContactPaneTab: string | null = null; // Used to override the tab displayed by default inside the contact pane

  private removeHotkeyListener: Function;

  arrayOfCustomerContactUIDs: {
    cuid: number,
    isClient: boolean,
    rs: RateScheduleHeader
  }[] = [];

  subscriptionArray: Subscription[] = [];
  preScreenOpenWithVehicle?: Vehicle = null;

  // alias objects
  truncateString = TruncateString;

  dashResortOptions: any;
  theme: IDashTheme = { name: 'ScaleTech', class: 'scaletechBg', color: 'white' };
  availableThemes: IDashTheme[] = [
    { name: 'Plain', class: 'whiteBg', color: '#212529' },
    { name: 'Slate', class: 'grayBg', color: 'white' },
    { name: 'ScaleTech', class: 'scaletechBg', color: 'white' }
  ];
  cancelData$ = new Subject<void>();
  forkSubscriber: Subscription;
  nonProtectedContactTypes: LU_STContactType[];

  massCTs: LU_STContactType[] = [];
  massContactsUIDs: number[] = [];
  massCTRemoveMode: boolean;

  cardTypes: {
    key: string;
    value: CardType;
  }[] = [];
  contactDebtLimitInput: string;
  workDone: any;
  totalWork: any;
  customerSelectOpen: boolean;
  customerSelectItems: STContact[] = [];
  statementEmailerOpen: boolean;
  showDashboard = true;

  constructor(
    public contactDashSvc: STContactDataService,
    public contactEmailSvc: ContactEmailService,
    public contactPhoneSvc: ContactPhonesService,
    public userSvc: UserDataService,
    public sbCmpMsgSvc: StarbaseComponentMessageService,
    protected logSvc: LogDataService,
    public jobDashSvc: JobDataService,
    public sthSvc: ScaleTicketHeaderDataService,
    public stdSvc: ScaleTicketDetailDataService,
    public fileSvc: ManifestFilesService,
    public invoiceSvc: InvoiceDataService,
    public rateSvc: RateScheduleDataService,
    private siteSvc: SiteDataService,
    public vehicleSvc: VehicleDataService,
    public gridSvc: LU_GridService,
    public matSubCatSvc: LU_MaterialSubCategoryService,
    public invoiceBatchSvc: LU_InvoiceBatchService,
    public matServSvc: LU_MaterialServiceService,
    protected jobCodeSvc: LU_JobCodeService,
    protected jobCatSvc: LU_JobCategoryService,
    public vehicleTypeSvc: LU_VehicleTypeService,
    protected batchSvc: LU_InvoiceBatchService,
    public webSocketSvc: WebSocketService,
    public sbSvcProvider: StarbaseServiceProviderService,
    public statusSvc: StatusServService,
    public paymentSvc: PaymentService,
    public eodBatchSvc: EODBatchService,
    public payPendSvc: PaymentPendingService,
    public dp: DecimalPipe,
    protected cd: ChangeDetectorRef,
    private fb: FormBuilder,
    public loginSvc: StarbaseLoginService,
    public notiSvc: StarbaseNotificationService,
    public modalSvc: StarbaseModalDialogService,
    public overlaySvc: StarbaseModalOverlayService,
    public appGlobals: AppGlobalsService,
    public appComponent: AppComponent,
    public scaleLinkSvc: ScaleLinkService,
    public termsSvc: LU_TermService,
    public kioskSvc: KioskService,
    public forteSvc: ForteService,
    public voucherSvc: VoucherService,
    public signatureSvc: SignatureService,
    protected dlScannerSvc: DLScannerService,
  ) {
    this.displayName = this.loginSvc.getDisplayName();
    this.dashResortOptions = {
      onUpdate: (e: any) => {
        this.changeDashOrder(e.newIndex, e.oldIndex);
      }
    };

    this.contactEmailTableViewOpts.columnHeaderTextAlignment = this.contactPhoneTableViewOpts.columnHeaderTextAlignment = 'center';
    this.contactEmailTableViewOpts.boldColloquialContent = this.contactPhoneTableViewOpts.boldColloquialContent = false;
  }

  get forteScriptURL() {
    return environment.FORTE_SCRIPT_URL;
  }

  @ViewChild('locationSelectModal') locationSelectModal: TemplateRef<any>;
  @ViewChild('emptyButtonOverrideTemplate') emptyButtonOverrideTemplate: TemplateRef<any>;

  pawneeDashModules: object[] = []; // list of dash module classes
  pawneeDashConfs: DashModuleBase<any>[];

  UIDQueues: { module: string, UIDs: number[] }[] = [];

  ngOnInit() {
    this.subscriptionArray.push(this.dlScannerSvc.init());

    this.manifestLengthOverride = environment.MANIFEST_LENGTH_OVERRIDE;
    this.cloverAppMarketUrl = environment.CLOVER_APP_MARKET_LINK;

    this.userTimeZone = UsTimezones().find(t => t.name === Intl.DateTimeFormat().resolvedOptions().timeZone) ||
    {
      name: 'Coordinated Universal Time (UTC)',
      offset: 'UTC',
      DSToffset: 'UTC'
    };

    if (this.appComponent && this.appComponent.mainMenu) {
      this.appComponent.mainMenu.showUserAccountMenu = false;
      this.appComponent.mainMenu.showNavMenu = false;
    }

    this.pawneeDashModules = [
      ScaleTicketHeaderDashComponent,
      InvoiceDashComponent,
      PaymentDashComponent,
      EodDashComponent,
      VehicleDashComponent,
      JobDashComponent,
      ContactDashComponent,
      StatusDashComponent,
      KioskDashComponent,
    ];

    this.contactsWatcherSubscription = this.contactDashSvc.refreshTrigger$.subscribe(
      (d) => this.getDashboardRequisiteData(d),
      (e) => console.error(e)
    );
    this.subscriptionArray.push(this.contactsWatcherSubscription);

    this.createContactWithUserSubscription = this.contactDashSvc.triggerNewContactWithUser.subscribe(
      () => this.openCreateContactWizard()
    );
    this.subscriptionArray.push(this.createContactWithUserSubscription);

    this.subscriptionArray.push(this.contactDashSvc.triggerCustomReport.subscribe((data) => this.exportCustomContactReport(data)));

    this.subscriptionArray.push(this.webSocketSvc.dashboardRefreshTrigger$.subscribe(() => this.sthSvc.triggerRefresh()))

    this.contactExcelExportSubscription = this.contactDashSvc.exportDataEmitter.subscribe(
      (fp) => {
        this.exportContactExcel(fp as FilterParams<STContact>);
      }
    );
    this.subscriptionArray.push(this.contactExcelExportSubscription);

    this.manageUserSubscription = this.contactDashSvc.triggerOpenUserAccount.subscribe(
      (id) => {
        this.editUserId = id;
        this.manageUser();
      }
    );
    this.subscriptionArray.push(this.manageUserSubscription);

    this.jobsWatcherSubscription = this.jobDashSvc.refreshTrigger$.subscribe(
      (d) => this.getDashboardRequisiteData(d),
      (e) => console.error(e)
    );
    this.subscriptionArray.push(this.jobsWatcherSubscription);

    this.dashboardCustomizationsModalListener = this.appGlobals.callDashboardCustomizationsModal.subscribe(
      (d: boolean) => {
        if (d) {
          this.openDashOptions();
          this.appGlobals.callDashboardCustomizationsModal.next(false);
        }
      }
    );
    this.subscriptionArray.push(this.dashboardCustomizationsModalListener);

    this.paymentWizardTicketModalListener = this.sthSvc.callPaymentWizardModal.subscribe(
      (t: number) => {
        if (t) {
          this.prepayMode = false;
          this.stMode = true;
          this.sthSvc.getData(this.sthSvc.getOneUri, t).subscribe(
            (sth: ScaleTicketHeader) => {
              this.ticket = sth;
              this.job = this.ticket.job;
              this.createPaymentWizOpen = true;
              this.overlaySvc.enableOverlay();
            }
          );
        }
      }
    )

    this.subscriptionArray.push(this.paymentWizardTicketModalListener);
    this.paymentWizardTicketInvoiceModalListener = this.sthSvc.callInvoicePaymentWizardModal.subscribe(
      (i: number) => {
        if (i) {
          this.invoiceSvc.getData(this.invoiceSvc.getOneUri, i).subscribe(
            (inv: Invoice) => {
              this.invoice = inv;
              this.hideACHPaymentOption = true;
              this.job = this.invoice.job
              this.invMode = true;
              this.createPaymentWizOpen = true;
              this.overlaySvc.enableOverlay();
            }
          );
        }
      }
    )

    this.subscriptionArray.push(this.paymentWizardTicketInvoiceModalListener);
    this.paymentWizardInvoiceModalListener = this.invoiceSvc.callPaymentWizardModal.subscribe(
      (i: number) => {
        if (i) {
          this.prepayMode = false;
          this.invoiceSvc.getData(this.invoiceSvc.getOneUri, i).subscribe(
            (inv: Invoice) => {
              this.invoice = inv;
              this.job = this.invoice.job
              this.invMode = true;
              this.hideACHPaymentOption = false;
              this.createPaymentWizOpen = true;
              this.overlaySvc.enableOverlay();
              this.cd.markForCheck();
            }
          );
        }
      }
    )
    this.subscriptionArray.push(this.paymentWizardInvoiceModalListener);

    this.sbCmpMsgNotifySubscription = this.sbCmpMsgSvc.messageForUserEmitter.subscribe((m: IMessage) => this.handleDashComponentMsg(m));
    this.sbCmpCmdSubscription = this.sbCmpMsgSvc.messageCommandEmitter.subscribe((m: IMessage) => this.handleDashComponentMsg(m));
    this.subscriptionArray.push(this.sbCmpMsgNotifySubscription, this.sbCmpCmdSubscription);

    let viewOptions = this.appGlobals.getViewOptions(this.emailViewOptsID);
    if (viewOptions) {
      viewOptions.optionsChanged = new Subject();
      this.contactEmailTableViewOpts = viewOptions;
    }

    this.subscriptionArray.push(
      this.contactEmailTableViewOpts.optionsChanged.subscribe((opts) => {
        const temp = opts.optionsChanged;
        opts.optionsChanged = undefined;
        this.appGlobals.setViewOptions(opts, this.emailViewOptsID);
        opts.optionsChanged = temp;
      })
    );

    viewOptions = undefined;

    viewOptions = this.appGlobals.getViewOptions(this.phoneViewOptsID);
    if (viewOptions) {
      viewOptions.optionsChanged = new Subject();
      this.contactPhoneTableViewOpts = viewOptions;
    }

    this.subscriptionArray.push(
      this.contactPhoneTableViewOpts.optionsChanged.subscribe((opts) => {
        const temp = opts.optionsChanged;
        opts.optionsChanged = undefined;
        this.appGlobals.setViewOptions(opts, this.phoneViewOptsID);
        opts.optionsChanged = temp;
      })
    );

    this.subscriptionArray.push(this.contactDashSvc.triggerMassContactTypeAssignment.subscribe((contacts: number[]) =>
      this.massContactTypes(contacts)));

    this.subscriptionArray.push(this.contactDashSvc.triggerMassContactTypeUnassignment.subscribe((contacts: number[]) =>
      this.massContactTypes(contacts, true)));

    this.subscriptionArray.push(this.sthSvc.triggerCreateTicketPreScreen.subscribe((data: { vehicle?: Vehicle }) => {
      this.launchScaleTicketPreScreen(data?.vehicle ?? null);
    }));

    this.subscriptionArray.push(this.sthSvc.triggerCreateCreditMemoPrescreen.subscribe((data: { vehicle?: Vehicle }) => {
      this.launchCreditMemoPreScreen(data?.vehicle ?? null);
    }));

    this.subscriptionArray.push(this.sthSvc.triggerOpenScaleTicketForEdit.subscribe((ticket) => {
      this.ticketEdit = true;
      this.openRecordType(ticket);
      setTimeout(() => {
        this.ticketEdit = false;
      }, 5000);
    }));

    this.subscriptionArray.push(this.invoiceSvc.triggerCreatePreScreen.subscribe((event) => {
      this.isCustStatement = event;
      this.launchReportPreScreen();
    }));


    this.subscriptionArray.push(this.invoiceSvc.triggerCreateInvoiceBatch.subscribe(() => {
      this.launchInvoiceBatchWizard();
    }));

    this.subscriptionArray.push(this.invoiceSvc.triggerOpenInvoiceRecordHistory.subscribe((guid) => {
      this.appComponent.handleRecordHistoryRequest(guid, false, false);
    }));

    this.subscriptionArray.push(this.jobDashSvc.triggerOpenRateSchedule.subscribe((job) => {
      this.viewJobRateSchedule(job);
    }));

    this.subscriptionArray.push(this.vehicleSvc.triggerCreateRollOff.subscribe(() => {
      const newVehicle = new Vehicle();
      newVehicle.contact = new STContact();
      newVehicle.active = true;
      this.vehiclePaneHandle.addMode = true;
      this.vehiclePaneHandle.editMode = false;
      this.vehiclePaneHandle.specialMode = true;
      this.overlaySvc.enableOverlay();
      this.vehiclePaneHandle.openPane(newVehicle);
    }));

    this.jobDashSvc.triggerRefresh();
    this.userSvc.getAllRequisiteData<UserGroupModel>(this.userSvc.GetUserGroupsUri).subscribe(
      (ug) => {
        this.userGroups = ug;
      }
    );
    // this.contactDashModule.quickActionMenuTemplate

    this.appGlobals.currentLoggedInUser.subscribe(a => {
      this.currentLoggedInUser = a;
      this.contactDashSvc.triggerRefresh();
      this.cd.markForCheck();
    });

    this.appGlobals.currentLoggedInContact.subscribe(a => this.currentLoggedInContact = a);
    this.registerHotkeyEvents();
  }

  ngAfterViewInit() {
    const loadedTheme = this.appGlobals.getDashTheme();
    if (loadedTheme) {
      this.switchTheme(loadedTheme);
    }

    this.siteSvc.getPrimarySite().subscribe((site) => {
      this.appGlobals.setSite(site);
      this.vouchersEnabled = site.voucherSystem !== VoucherSystemEnum.NONE;
      this.initLocation();
      // Can only start booting the dash modules AFTER the site and locations data loads.
      // This prevents dashboards like tickets/payments etc... from loading data not available to that user
      if (!this.booted) {
        this.cd.detectChanges();
        this.bootDashModules();
      }
    });
  }

  private initLocation() {
    if (this.appGlobals.site.enableMultiLocations && (!this.appGlobals.selectedLocation && !this.appGlobals.viewingAllLocations)) {
      const jwt = new JwtHelperService().decodeToken(this.loginSvc.getToken());
      this.appGlobals.currentUser = jwt["User"]; //Added so that the getDefaultLocation does not fail due to race condition
      const accessToAll = jwt["AccessToAllLocations"] === "True";

      if (typeof jwt["Locations"] === "string") {
        const loc = new LocationModel();
        loc.uid = parseInt(jwt["Locations"].split(":")[0]);
        loc.locationName = jwt["Locations"].split(":")[1];
        this.appGlobals.setAvailableLocations([loc], accessToAll);
        this.appGlobals.setSelectedLocation(loc, false);
      } else {
        this.appGlobals.setSelectedLocation(null, false);
        this.appGlobals.setAvailableLocations(jwt["Locations"].map((locStr: string) => {
          const l = new LocationModel();
          l.uid = parseInt(locStr.split(":")[0]);
          l.locationName = locStr.split(":")[1];
          return l;
        }), accessToAll);
        const dLocUID = this.appGlobals.getDefaultLocation();
        let dLocInAvailable: boolean = this.appGlobals.availableLocations.some(
          l => l.uid == dLocUID
        );
        if(!dLocInAvailable && dLocUID == 0 && accessToAll){
          dLocInAvailable = true;
        }
        if(dLocUID != null && dLocInAvailable){
          this.selectActiveLocation(this.appGlobals.availableLocations.find(l => l.uid === dLocUID),dLocUID == 0)
        } else {
          this.showLocationSelectModal();
        }
      }
    }
  }

  public showLocationSelectModal() {
    this.sbSvcProvider.overlaySvc.enableOverlay();
    const modal = new StarbaseModalOptions('Select Location', '', [], StarbaseModalTypes.Custom, this.locationSelectModal);
    modal.dismissable = false;
    modal.buttonControlsOverrideTemplate = this.emptyButtonOverrideTemplate;
    this.sbSvcProvider.modalSvc.postModal(modal);
  }

  public closeLocationSelectModal() {
    this.sbSvcProvider.overlaySvc.disableOverlay();
    if (this.sbSvcProvider.modalSvc.isCurrentlyModal()) {
      this
      this.sbSvcProvider.modalSvc.closeModal("closed location selection");
    }
  }

  public selectActiveLocation(loc: LocationModel, selectedAll: boolean) {
    this.closeLocationSelectModal();
    this.appGlobals.setSelectedLocation(loc, selectedAll);
    this.sbSvcProvider.notificationSvc.postNotification(
      this.sbSvcProvider.notificationSvc.notificationBuilder('Location Changed', `Your selected location has changed to ${loc ? loc.locationName : "ALL Locations"}`, undefined, 10_000, StarbaseNotificationSentiment.Info)
    );
  }

  ngOnDestroy() {
    this.cancelData$.next();
    this.cancelData$.complete();
    this.contactDashSvc.dataFilterParamsCancel$.next();
    this.contactDashSvc.dataGetAllCancel$.next();
    this.contactDashSvc.dataGetAllReqCancel$.next();
    this.subscriptionArray.forEach(
      s => {
        if (s) {
          s.unsubscribe();
        }
      }
    );
  }

  /** Adjust multiple Contact Type assignment over multiple Contact records (add or remove links).  */
  private massContactTypes(contacts: number[], removeMode = false): void {
    this.massCTRemoveMode = removeMode;
    this.massCTs = []; // reset from last time
    this.massContactsUIDs = contacts;
    if (!contacts.length) { return; }
    const saveBtn = new StarbaseModalButton('Save', () => {
      this.massCTs = removeDuplicateItems(this.massCTs, 'uid');
      if (!removeMode) {
        this.contactDashSvc.saveMassCTAssignment({ contactUIDs: contacts, contactTypeUIDs: this.massCTs.map(c => c.uid) }).subscribe(
          () => {
            this.modalSvc.closeModal('User did the thing');
            this.contactDashSvc.triggerRefresh(undefined, true);
          },
          // eslint-disable-next-line max-len
          (e) => this.notiSvc.postNotification(this.notiSvc.notificationBuilder('CT Assignment Failed', `${e.friendly} ${e.serverMsg[0]}`, undefined, undefined, StarbaseNotificationSentiment.Error))
        );
      } else {
        this.contactDashSvc.saveMassCTUnassignment({ contactUIDs: contacts, contactTypeUIDs: this.massCTs.map(c => c.uid) }).subscribe(
          () => {
            this.modalSvc.closeModal('User did the thing');
            this.contactDashSvc.triggerRefresh(undefined, true);
          },
          // eslint-disable-next-line max-len
          (e) => this.notiSvc.postNotification(this.notiSvc.notificationBuilder('CT Unassignment Failed', `${e.friendly} ${e.serverMsg[0]}`, undefined, undefined, StarbaseNotificationSentiment.Error))
        );
      }
    }, () => this.massCTs.length > 0);
    const ctAssignModalObj = new StarbaseModalOptions(
      removeMode ? 'Unassign Contact TYpes' : 'Assign Contact Types',
      undefined,
      [
        saveBtn,
        new StarbaseModalButton('Cancel', () => this.modalSvc.closeModal('User cancelled'))
      ],
      StarbaseModalTypes.Success,
      this.ctAssignModal);
    ctAssignModalObj.forcedHeight = '16em';
    ctAssignModalObj.forcedWidth = '40vw';
    this.modalSvc.postModal(ctAssignModalObj);
  }

  unsavedChangesCheck() {
    if (!this.createContactWithUserWizOpen) {
      return true;
    }
    const obs$ = new Subject<boolean>();
    const modal =
      new StarbaseModalOptions(
        'Discard data changes?',
        `You have unsaved changes. If you leave now those changes will be lost.`,
        [
          new StarbaseModalButton(
            'Yes',
            () => { obs$.next(true); this.modalSvc.closeModal('User chose yes'); }),
          new StarbaseModalButton(
            'No',
            () => { obs$.next(false); this.modalSvc.closeModal('User chose no'); })
        ],
        StarbaseModalTypes.Warning
      );
    modal.dismissable = false;
    this.modalSvc.postModal(modal);
    return obs$;
  }

  public isAdmin(): boolean {
    try {
      return (this.loginSvc.isLoggedIn()) ? this.loginSvc.getUserModel().isAdmin() : false;
    } catch {
      return false;
    }
  }

  /** Called by dash modules when opening a record.  */
  updateUIDQueues(data: { module: string, UIDs: number[] }): void {
    const s = this.UIDQueues.find(m => m.module === data.module);
    if (s) {
      s.UIDs = data.UIDs;
    } else {
      this.UIDQueues.push(data);
    }
  }

  getUIDQueueForModule(module: string): number[] {
    try {
      return this.UIDQueues.find(q => q.module === module).UIDs || [];
    } catch {
      return [];
    }
  }

  private getDashboardRequisiteData(onlyType?: object) {
    if (this.loadingRequisiteData) {
      return;
    }

    this.loadingRequisiteData = true;
    this.cancelData$.next();
    const contactDataForks: Observable<any>[] = [
      this.contactDashSvc.getAllRequisiteData<LU_STContactType>(this.contactDashSvc.getUriByName('getAllContactTypesUri')),
      this.userSvc.getAllRequisiteData<UserGroupModel>(this.userSvc.GetUserGroupsUri),
      this.contactDashSvc.getAllData(),
      this.termsSvc.getAllData(this.termsSvc.getAllUri)
    ];

    const rateDataForks: Observable<any>[] = [
      this.matServSvc.getAllData(this.matServSvc.getAllUri)
    ];

    const vehicleDataForks: Observable<any>[] = [
      this.vehicleTypeSvc.getAllData(this.vehicleTypeSvc.getAllUri)
    ];

    const scaleTicketDataForks: Observable<any>[] = [
      //this.invoiceSvc.getAllData(this.invoiceSvc.getAllUri),
      of([]),
      this.gridSvc.getAllData(this.gridSvc.getAllUri),
      this.matSubCatSvc.getAllData(this.matSubCatSvc.getAllUri),
      //this.vehicleSvc.getAllData(this.vehicleSvc.getAllUri)
    ];

    const invoiceDataForks: Observable<any>[] = [
      this.invoiceBatchSvc.getAllData(this.invoiceBatchSvc.getAllUri)
    ];

    const sharedDataForks: Observable<any>[] = [
      this.siteSvc.getAllData(this.siteSvc.getAllUri),
      this.contactDashSvc.getCustomers(),
      this.jobDashSvc.getAllData(this.jobDashSvc.getAllUri),
      this.jobCodeSvc.getAllData(this.jobCodeSvc.getAllUri),
      this.jobCatSvc.getAllData(this.jobCatSvc.getAllUri)
    ];

    const allForks: Observable<any>[] = [];
    switch (true) {
      case onlyType instanceof ContactModel:
        allForks.push(...contactDataForks);
        break;
      default:
        allForks.push(
          ...contactDataForks,
          ...rateDataForks,
          ...vehicleDataForks,
          ...scaleTicketDataForks,
          ...invoiceDataForks,
          ...sharedDataForks
        );
        break;
    }

    this.forkSubscriber = forkJoin(allForks).pipe().subscribe(([
      contactTypes,
      userGroups,
      contacts,
      terms,
      matServs,
      vehicleTypes,
      invoices,
      grids,
      matSubCats,
      //vehicles,
      invoiceBatches,
      sites,
      customers,
      jobs,
      jobCodes,
      jobCategories
    ]: [
        LU_STContactType[],
        UserGroupModel[],
        ContactModel[],
        LU_TermsModel[],
        LU_MaterialService[],
        LU_VehicleType[],
        Invoice[],
        LU_Grid[],
        LU_MaterialSubCategory[],
        //Vehicle[],
        LU_InvoiceBatch[],
        Site[],
        STContact[],
        Job[],
        LU_JobCode[],
        LU_JobCategory[]
      ]) => {
      this.preLoadContactTypes = contactTypes;
      this.nonProtectedContactTypes = contactTypes.filter(i => i.protected === false);
      this.userGroups = userGroups;
      this.terms = terms;
      this.activeTerms = terms.filter(t => t.active == true);
      this.contactDashSvc.ContactTypeDataStore = contactTypes;
      this.materialsAndServices = matServs;
      this.vehicleTypes = vehicleTypes;
      this.vehicleSvc.VehicleTypeDataStore = vehicleTypes;
      this.invoices = invoices;
      this.sthSvc.InvoiceDataStore = invoices;
      this.grids = grids;
      this.matSubCats = matSubCats;
      //this.vehicles = vehicles;
      this.invoiceBatches = invoiceBatches;
      this.invoiceSvc.InvoiceBatchDataStore = invoiceBatches;
      this.sites = sites;
      this.sthSvc.SiteDataStore = sites;
      this.invoiceSvc.SiteDataStore = sites;
      this.customers = customers;
      this.activeCustomers = customers.filter(x => x.active);
      this.jobDashSvc.CustomerDataStore = customers;
      this.sthSvc.CustomerDataStore = customers;
      this.invoiceSvc.CustomerDataStore = customers;
      this.jobs = jobs;
      this.sthSvc.JobDataStore = jobs;
      this.invoiceSvc.JobDataStore = jobs;
      this.jobCodes = jobCodes;
      this.jobDashSvc.JobCodeDataStore = jobCodes;
      this.sthSvc.JobCodeDataStore = jobCodes;
      this.jobCategories = jobCategories;
      this.jobDashSvc.JobCategoryDataStore = jobCategories;
      this.sthSvc.JobCategoryDataStore = jobCategories;
      this.loadingRequisiteData = false;
    },
      e => {
        this.loadingRequisiteData = false;
        console.error(e);
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder('Error Loading',
            'Supporting data for dash modules failed to load.',
            StarbaseNotificationTypes.Error
          )
        );
      },
      () => {
        this.loadingRequisiteData = false;
        this.contactDashModule.supportingDataArray = this.preLoadContactTypes;

        this.vehicleDashModule.supportingDataArray = [this.vehicleTypes];

        this.sthDashModule.supportingDataArray = [
          this.sites,
          this.customers,
          this.jobs,
          this.jobCodes,
          this.jobCategories,
          this.invoices,
          this.grids
        ];


        this.jobDashModule.supportingDataArray = [
          this.jobCodes,
          this.jobCategories,
          this.customers
        ];

        this.invoiceDashModule.supportingDataArray = [
          this.sites,
          this.customers,
          this.jobs,
          this.invoiceBatches
        ];

        this.contactDashModule.setupSupportingData();
        this.vehicleDashModule.setupSupportingData();
        this.sthDashModule.setupSupportingData();
        this.jobDashModule.setupSupportingData();
        this.invoiceDashModule.setupSupportingData();
        this.statusDashModule.setupSupportingData();
        this.kioskDashModule.setupSupportingData();
        this.paymentDashModule.setupSupportingData();
        this.eodDashModule.setupSupportingData();
      }
    );

  }

  private bootDashModules(): void {
    this.currentUser = this.loginSvc.getUserModel();
    this.scaleLinkSvc.initScaleLink(this.appGlobals.site, environment.useDebugSerialConnection);

    let jobDashConf: DashConfSave;
    let sthDashConf: DashConfSave;
    let invoiceDashConf: DashConfSave;
    let contactDashConf: DashConfSave;
    let vehicleDashConf: DashConfSave;
    let statusDashConf: DashConfSave;
    let kioskDashConf: DashConfSave;
    let paymentDashConf: DashConfSave;
    let eodDashConf: DashConfSave;
    const dashConf = this.appGlobals.getDashConf();

    let tempConfs: DashConfSave[] = null;

    if (dashConf.modules && dashConf.modules.length && dashConf.confs.some(c => c.moduleID.includes(this.paymentDashModule.ModuleID))) {
      this.pawneeDashModules = [];
      dashConf.modules.forEach(m => {
        this.pawneeDashModules.push(this.getModuleByName(m));
      });

      if (!this.pawneeDashModules.some(x => x === InvoiceDashComponent)) {
        this.pawneeDashModules.push(InvoiceDashComponent); // Add incase of switching from scale house user to admin/Bookkeeper
      }

      if (!this.pawneeDashModules.some(x => x === StatusDashComponent)) {
        this.pawneeDashModules.push(StatusDashComponent);
      }

      if (!this.pawneeDashModules.some(x => x === KioskDashComponent)) {
        this.pawneeDashModules.push(KioskDashComponent);
      }

      if (!this.pawneeDashModules.some(x => x === PaymentDashComponent)) {
        this.pawneeDashModules.push(PaymentDashComponent);
      }

      if (!this.pawneeDashModules.some(x => x === EodDashComponent)) {
        this.pawneeDashModules.push(EodDashComponent);
      }

      try {
        tempConfs = dashConf.confs;
        jobDashConf = tempConfs.find(c => c.moduleID.includes(this.jobDashModule.ModuleID));
        sthDashConf = tempConfs.find(c => c.moduleID.includes(this.sthDashModule.ModuleID));
        invoiceDashConf = tempConfs.find(c => c.moduleID.includes(this.invoiceDashModule.ModuleID));
        contactDashConf = tempConfs.find(c => c.moduleID.includes(this.contactDashModule.ModuleID));
        vehicleDashConf = tempConfs.find(c => c.moduleID.includes(this.vehicleDashModule.ModuleID));
        statusDashConf = tempConfs.find(c => c.moduleID.includes(this.statusDashModule.ModuleID));
        kioskDashConf = tempConfs.find(c => c.moduleID.includes(this.kioskDashModule.ModuleID));
        paymentDashConf = tempConfs.find(c => c.moduleID.includes(this.paymentDashModule.ModuleID));
        eodDashConf = tempConfs.find(c => c.moduleID.includes(this.eodDashModule.ModuleID));
      } catch {
        tempConfs = null;
      }
    }

    // eslint-disable-next-line max-len
    let newDashConf = new DashConf('Jobs', this.jobDashModule.ModuleID, 'fa-money-check-edit', 'fa-money-check-edit', 25, '#eab517');
    newDashConf.hotKey = "j";
    newDashConf.zebraStripe = true;
    newDashConf.stickyMode = true;
    newDashConf.maximized = true;
    this.jobDashModule.dashConf = tempConfs && jobDashConf ? jobDashConf : newDashConf;
    this.jobDashModule.dashConf.hotKey = "j";
    this.jobDashModule.boxTitle = 'Jobs';
    this.jobDashModule.boxMainColor = tempConfs && jobDashConf ? jobDashConf.boxMainColor : '#eab517';
    this.jobDashModule.isAdmin = this.isAdmin();
    this.jobDashModule.dataService = this.jobDashSvc;
    this.jobDashModule.startMaximized = tempConfs && jobDashConf ? jobDashConf.maximized : true;
    this.jobDashModule.startMinimized = tempConfs && jobDashConf ? jobDashConf.minimized : false;
    this.jobDashModule.boxMainIconClass = tempConfs && jobDashConf ? jobDashConf.boxMainIconClass : 'fa-money-check-edit';
    this.jobDashModule.addNewIconClass = tempConfs && jobDashConf ? jobDashConf.boxMainIconClass : 'fa-money-check-edit';
    this.jobDashModule.timeZoneOffset = this.isDstObserved() ? this.userTimeZone.DSToffset : this.userTimeZone.offset;
    this.jobDashModule.supportingDataArray = [
      this.jobCodes,
      this.jobCategories,
      this.customers
    ];

    // eslint-disable-next-line max-len
    newDashConf = new DashConf('Scale Tickets', this.sthDashModule.ModuleID, 'fa-truck-container', 'fa-truck-container', 25, '#3ebe40');
    newDashConf.hotKey = "t";
    newDashConf.zebraStripe = true;
    newDashConf.stickyMode = true;
    newDashConf.maximized = true;
    /*
     * Configuration of Scale Ticket Header Dash
     */
    this.sthDashModule.dashConf = tempConfs && sthDashConf ? sthDashConf : newDashConf;
    this.sthDashModule.dashConf.hotKey = "t";
    this.sthDashModule.boxTitle = 'Scale Tickets';
    this.sthDashModule.boxMainColor = tempConfs && sthDashConf ? sthDashConf.boxMainColor : '#3ebe40';
    this.sthDashModule.isAdmin = this.isAdmin();
    this.sthDashModule.dataService = this.sthSvc;
    this.sthDashModule.startMaximized = tempConfs && sthDashConf ? sthDashConf.maximized : true;
    this.sthDashModule.startMinimized = tempConfs && sthDashConf ? sthDashConf.minimized : false;
    this.sthDashModule.boxMainIconClass = tempConfs && sthDashConf ? sthDashConf.boxMainIconClass : 'fa-truck-container';
    this.sthDashModule.addNewIconClass = tempConfs && sthDashConf ? sthDashConf.boxMainIconClass : 'fa-truck-container';
    this.sthDashModule.timeZoneOffset = this.isDstObserved() ? this.userTimeZone.DSToffset : this.userTimeZone.offset;
    this.sthDashModule.supportingDataArray = [
      this.sites,
      this.customers,
      this.jobs,
      this.jobCodes,
      this.jobCategories,
      this.invoices
    ];

    // eslint-disable-next-line max-len
    newDashConf = new DashConf('Vehicles', this.vehicleDashModule.ModuleID, 'fa-truck-pickup', 'fa-truck-pickup', 25, '#e01e1f');
    newDashConf.hotKey = "v";
    newDashConf.zebraStripe = true;
    newDashConf.stickyMode = true;
    newDashConf.maximized = true;
    this.vehicleDashModule.dashConf = tempConfs && vehicleDashConf ? vehicleDashConf : newDashConf;
    this.vehicleDashModule.dashConf.hotKey = "v";
    this.vehicleDashModule.boxTitle = 'Vehicles';
    this.vehicleDashModule.boxMainColor = tempConfs && vehicleDashConf ? vehicleDashConf.boxMainColor : '#e01e1f';
    this.vehicleDashModule.isAdmin = this.isAdmin();
    this.vehicleDashModule.dataService = this.vehicleSvc;
    this.vehicleDashModule.startMaximized = tempConfs && vehicleDashConf ? vehicleDashConf.maximized : true;
    this.vehicleDashModule.startMinimized = tempConfs && vehicleDashConf ? vehicleDashConf.minimized : false;
    this.vehicleDashModule.boxMainIconClass = tempConfs && vehicleDashConf ? vehicleDashConf.boxMainIconClass : 'fa-truck-pickup';
    this.vehicleDashModule.addNewIconClass = tempConfs && vehicleDashConf ? vehicleDashConf.boxMainIconClass : 'fa-truck-pickup';
    this.vehicleDashModule.timeZoneOffset = this.isDstObserved() ? this.userTimeZone.DSToffset : this.userTimeZone.offset;
    this.vehicleDashModule.supportingDataArray = [this.vehicleTypes];

    // eslint-disable-next-line max-len
    newDashConf = new DashConf('Invoices', this.invoiceDashModule.ModuleID, 'fa-file-invoice-dollar', 'fa-file-invoice-dollar', 25, '#399079');
    newDashConf.hotKey = "i";
    newDashConf.zebraStripe = true;
    newDashConf.stickyMode = true;
    newDashConf.maximized = true;
    this.invoiceDashModule.dashConf = tempConfs && invoiceDashConf ? invoiceDashConf : newDashConf;
    this.invoiceDashModule.dashConf.hotKey = "i";
    this.invoiceDashModule.boxTitle = 'Invoices';
    this.invoiceDashModule.boxMainColor = tempConfs && invoiceDashConf ? invoiceDashConf.boxMainColor : '#399079';
    this.invoiceDashModule.isAdmin = this.isAdmin();
    this.invoiceDashModule.dataService = this.invoiceSvc;
    this.invoiceDashModule.startMaximized = tempConfs && invoiceDashConf ? invoiceDashConf.maximized : true;
    this.invoiceDashModule.startMinimized = tempConfs && invoiceDashConf ? invoiceDashConf.minimized : false;
    this.invoiceDashModule.boxMainIconClass = tempConfs && invoiceDashConf ? invoiceDashConf.boxMainIconClass : 'fa-file-invoice-dollar';
    this.invoiceDashModule.addNewIconClass = tempConfs && invoiceDashConf ? invoiceDashConf.boxMainIconClass : 'fa-file-invoice-dollar';
    this.invoiceDashModule.timeZoneOffset = this.isDstObserved() ? this.userTimeZone.DSToffset : this.userTimeZone.offset;
    this.invoiceDashModule.supportingDataArray = [
      this.sites,
      this.customers,
      this.jobs,
      this.invoiceBatches
    ];

    // eslint-disable-next-line max-len
    newDashConf = new DashConf('Status', this.statusDashModule.ModuleID, 'fa-tachometer', 'fa-tachometer', 25, '#000000');
    newDashConf.hotKey = "x";
    newDashConf.maximized = true;
    this.statusDashModule.dashConf = tempConfs && statusDashConf ? statusDashConf : newDashConf;
    this.statusDashModule.dashConf.hotKey = "x";
    this.statusDashModule.boxTitle = 'Status';
    this.statusDashModule.boxMainColor = tempConfs && statusDashConf ? statusDashConf.boxMainColor : '#000000';
    this.statusDashModule.isAdmin = this.isAdmin();
    this.statusDashModule.dataService = this.statusSvc;
    this.statusDashModule.startMaximized = tempConfs && statusDashConf ? statusDashConf.maximized : true;
    this.statusDashModule.startMinimized = tempConfs && statusDashConf ? statusDashConf.minimized : false;
    this.statusDashModule.boxMainIconClass = tempConfs && statusDashConf ? statusDashConf.boxMainIconClass : 'fa-tachometer';
    this.statusDashModule.addNewIconClass = tempConfs && statusDashConf ? statusDashConf.boxMainIconClass : 'fa-tachometer';
    this.statusDashModule.timeZoneOffset = this.isDstObserved() ? this.userTimeZone.DSToffset : this.userTimeZone.offset;


    // eslint-disable-next-line max-len
    newDashConf = new DashConf('Contract Accounts', this.kioskDashModule.ModuleID, 'fa-file-contract', 'fa-file-contract', 25, '#FFA500');
    newDashConf.hotKey = "k";
    newDashConf.zebraStripe = true;
    newDashConf.stickyMode = true;
    newDashConf.maximized = true;
    this.kioskDashModule.dashConf = tempConfs && kioskDashConf ? kioskDashConf : newDashConf;
    this.kioskDashModule.dashConf.hotKey = "k";
    this.kioskDashModule.boxTitle = 'Contract Accounts';
    this.kioskDashModule.boxMainColor = tempConfs && kioskDashConf ? kioskDashConf.boxMainColor : '#FFA500';
    this.kioskDashModule.isAdmin = this.isAdmin();
    this.kioskDashModule.dataService = this.kioskSvc;
    this.kioskDashModule.startMaximized = tempConfs && kioskDashConf ? kioskDashConf.maximized : true;
    this.kioskDashModule.startMinimized = tempConfs && kioskDashConf ? kioskDashConf.minimized : false;
    this.kioskDashModule.boxMainIconClass = tempConfs && kioskDashConf ? kioskDashConf.boxMainIconClass : 'fa-file-contract';
    this.kioskDashModule.addNewIconClass = tempConfs && kioskDashConf ? kioskDashConf.boxMainIconClass : 'fa-file-contract';
    this.kioskDashModule.timeZoneOffset = this.isDstObserved() ? this.userTimeZone.DSToffset : this.userTimeZone.offset;

    // eslint-disable-next-line max-len
    newDashConf = new DashConf('Payments', this.paymentDashModule.ModuleID, 'fa-money-check-alt', 'fa-money-check-alt', 25, '#0a8a06');
    newDashConf.hotKey = "p";
    newDashConf.zebraStripe = true;
    newDashConf.stickyMode = true;
    newDashConf.maximized = true;
    this.paymentDashModule.dashConf = tempConfs && paymentDashConf ? paymentDashConf : newDashConf;
    this.paymentDashModule.dashConf.hotKey = "p";
    this.paymentDashModule.boxTitle = 'Payments';
    this.paymentDashModule.boxMainColor = tempConfs && paymentDashConf ? paymentDashConf.boxMainColor : '#0a8a06';
    this.paymentDashModule.isAdmin = this.isAdmin();
    this.paymentDashModule.dataService = this.paymentSvc;
    this.paymentDashModule.startMaximized = tempConfs && paymentDashConf ? paymentDashConf.maximized : true;
    this.paymentDashModule.startMinimized = tempConfs && paymentDashConf ? paymentDashConf.minimized : false;
    this.paymentDashModule.boxMainIconClass = tempConfs && paymentDashConf ? paymentDashConf.boxMainIconClass : 'fa-money-check-alt';
    this.paymentDashModule.addNewIconClass = tempConfs && paymentDashConf ? paymentDashConf.boxMainIconClass : 'fa-money-check-alt';
    this.paymentDashModule.timeZoneOffset = this.isDstObserved() ? this.userTimeZone.DSToffset : this.userTimeZone.offset;

    newDashConf = new DashConf('EOD Batch', this.eodDashModule.ModuleID, 'fa-receipt', 'fa-receipt', 25, '#ad6bde');
    newDashConf.hotKey = "b";
    newDashConf.zebraStripe = true;
    newDashConf.stickyMode = true;
    newDashConf.maximized = true;
    this.eodDashModule.dashConf = tempConfs && eodDashConf ? eodDashConf : newDashConf;
    this.eodDashModule.dashConf.hotKey = "b";
    this.eodDashModule.boxTitle = 'EOD Batch';
    this.eodDashModule.boxMainColor = tempConfs && eodDashConf ? eodDashConf.boxMainColor : '#ad6bde';
    this.eodDashModule.isAdmin = this.isAdmin();
    this.eodDashModule.dataService = this.eodBatchSvc;
    this.eodDashModule.startMaximized = tempConfs && eodDashConf ? eodDashConf.maximized : true;
    this.eodDashModule.startMinimized = tempConfs && eodDashConf ? eodDashConf.minimized : false;
    this.eodDashModule.boxMainIconClass = tempConfs && eodDashConf ? eodDashConf.boxMainIconClass : 'fa-receipt';
    this.eodDashModule.addNewIconClass = tempConfs && eodDashConf ? eodDashConf.boxMainIconClass : 'fa-receipt';
    this.eodDashModule.timeZoneOffset = this.isDstObserved() ? this.userTimeZone.DSToffset : this.userTimeZone.offset;


    // eslint-disable-next-line max-len
    newDashConf = new DashConf('Contacts', this.contactDashModule.ModuleID, this.contactDashModule.boxMainIconClass, this.contactDashModule.addNewIconClass, 25, this.contactDashModule.boxMainColor);
    newDashConf.hotKey = "c";
    newDashConf.zebraStripe = true;
    newDashConf.stickyMode = true;
    newDashConf.maximized = true;
    let contactSearchSettings = this.appGlobals.getSearchSettings('contacts');
    // eslint-disable-next-line max-len
    this.contactDashModule.dashConf = (tempConfs && contactDashConf ? contactDashConf : newDashConf) as ContactDashConf;
    this.contactDashModule.dashConf.hotKey = "c";
    if (contactSearchSettings) {
      this.contactDashModule.dashConf.searchFilters = contactSearchSettings;
    }

    this.contactDashModule.boxMainColor = tempConfs && contactDashConf ? contactDashConf.boxMainColor : this.contactDashModule.boxMainColor;
    this.contactDashModule.isAdmin = this.isAdmin();
    this.contactDashModule.dataService = this.contactDashSvc;
    this.contactDashModule.startMaximized = tempConfs && contactDashConf ? contactDashConf.maximized : true;
    this.contactDashModule.startMinimized = tempConfs && contactDashConf ? contactDashConf.minimized : false;
    // eslint-disable-next-line max-len
    this.contactDashModule.boxMainIconClass = tempConfs && contactDashConf ? contactDashConf.boxMainIconClass : this.contactDashModule.boxMainIconClass;
    // eslint-disable-next-line max-len
    this.contactDashModule.addNewIconClass = tempConfs && contactDashConf ? contactDashConf.boxMainIconClass : this.contactDashModule.addNewIconClass;
    this.contactDashModule.quickActionMenuTemplate = this.qatemplate;
    this.contactDashModule.timeZoneOffset = this.isDstObserved() ? this.userTimeZone.DSToffset : this.userTimeZone.offset;
    this.contactDashModule.dashConf.backEndSearch = true;

    this.contactDashModule.dashConf.headerTemplate1 = this.contactDashTemplate1Override;

    const defaultCCHeaders = this.contactDashModule.defaultColumnHeaders;
    this.contactDashModule.columnHeaders = [
      new DashModuleColumnConf('contactUID', 'ID', true, ['contactUID']),
      ...defaultCCHeaders,
      this.appGlobals.site?.paymentsActive ? new DashModuleColumnConf('accountCredit', 'Credit', true, ['AccountCredit'],) : new DashModuleColumnConf('certOfInsuranceExpDate', 'COI Exp', true, ['CertOfInsuranceExpDate']),
      new DashModuleColumnConf('materialsTestExpDate', 'Mat Exp', true, ['MaterialsTestExpDate']),
      new DashModuleColumnConf('saExecutedDate', 'SA Date', true, ['SAExecutedDate'])
    ];

    this.contactDashModule.dashColumnContent0 = this.uidCol;
    this.contactDashModule.dashColumnContentN = this.endCols;

    this.contactDashModule.tooltipDarkMode = this.appGlobals.getStoredDarkModeSetting();
    this.contactDashModule.tooltipGlassMode = this.appGlobals.getStoredGlassModeSetting();
    this.contactDashModule.supportingDataArray = [this.preLoadContactTypes, [], this.appGlobals.site.paymentsActive ? [{ text: 'Account Credit Report', report: 'AccCredit', icon: 'fa-file-invoice-dollar' }, { text: 'Batch Email Customer Statements', report: 'CSBatch', icon: 'fal fa-envelope' }] : []];
    this.contactDashModule.sendMessageEmitter.subscribe((c) => this.receiveSendMessage(c));

    if (tempConfs && tempConfs.length === this.pawneeDashModules.length) {
      const confsToCheck = [
        this.sthDashModule,
        this.invoiceDashModule,
        this.paymentDashModule,
        this.eodDashModule,
        this.vehicleDashModule,
        this.jobDashModule,
        this.contactDashModule,
        this.statusDashModule,
        this.kioskDashModule,
      ];

      this.pawneeDashConfs = [];
      tempConfs.forEach(c => {
        this.pawneeDashConfs.push(confsToCheck.find(a => a.boxTitle === c.boxTitle));
      });
    } else if (tempConfs && tempConfs.length <= 7 // Handle instance where non-scalehouse worker signs on to scalehouse machine.
      && !tempConfs.some(c => c.boxTitle === this.eodDashModule.boxTitle)) {
      const confsToCheck = [
        this.sthDashModule,
        this.invoiceDashModule,
        this.paymentDashModule,
        this.vehicleDashModule,
        this.jobDashModule,
        this.contactDashModule,
        this.statusDashModule,
        this.kioskDashModule,
      ];
      this.pawneeDashConfs = [];
      tempConfs.forEach(c => {
        this.pawneeDashConfs.push(confsToCheck.find(a => a.boxTitle === c.boxTitle));
      });
      this.pawneeDashConfs.push(this.eodDashModule);
    } else {
      this.pawneeDashConfs = [
        this.sthDashModule,
        this.invoiceDashModule,
        this.paymentDashModule,
        this.eodDashModule,
        this.vehicleDashModule,
        this.jobDashModule,
        this.contactDashModule,
        this.statusDashModule,
        this.kioskDashModule,
      ];
    }

    if (this.currentUser && !this.currentUser.hasPermissions('contactsread') && !this.isAdmin()) {
      this.pawneeDashConfs = this.pawneeDashConfs.filter(x => x.ModuleID !== ContactDashComponent.moduleID);
      this.pawneeDashModules = this.pawneeDashModules.filter(x => !(x === ContactDashComponent));
    }

    if (this.currentUser && !this.currentUser.hasPermissions('jobsread') && !this.isAdmin()) {
      this.pawneeDashConfs = this.pawneeDashConfs.filter(x => x.ModuleID !== JobDashComponent.moduleID);
      this.pawneeDashModules = this.pawneeDashModules.filter(x => !(x === JobDashComponent));
    }

    if (this.currentUser && !this.currentUser.hasPermissions('scaleread') && !this.isAdmin()) {
      this.pawneeDashConfs = this.pawneeDashConfs.filter(x => x.ModuleID !== ScaleTicketHeaderDashComponent.moduleID);
      this.pawneeDashModules = this.pawneeDashModules.filter(x => !(x === ScaleTicketHeaderDashComponent));
    }

    if (this.currentUser && !this.currentUser.hasPermissions('invoiceread') && !this.isAdmin()) {
      this.pawneeDashConfs = this.pawneeDashConfs.filter(x => x.ModuleID !== InvoiceDashComponent.moduleID);
      this.pawneeDashModules = this.pawneeDashModules.filter(x => !(x === InvoiceDashComponent));
    }

    if (this.currentUser && !this.currentUser.hasPermissions('vehicleread') && !this.isAdmin()) {
      this.pawneeDashConfs = this.pawneeDashConfs.filter(x => x.ModuleID !== VehicleDashComponent.moduleID);
      this.pawneeDashModules = this.pawneeDashModules.filter(x => !(x === VehicleDashComponent));
    }

    if (!this.appGlobals.site?.statusActive) {
      this.pawneeDashConfs = this.pawneeDashConfs.filter(x => x.ModuleID !== StatusDashComponent.moduleID);
      this.pawneeDashModules = this.pawneeDashModules.filter(x => !(x === StatusDashComponent));
    }

    if (!this.appGlobals.site?.paymentsActive || (!this.currentUser.hasPermissions('paymentread') && !this.isAdmin())) {
      this.pawneeDashConfs = this.pawneeDashConfs.filter(x => x.ModuleID !== PaymentDashComponent.moduleID);
      this.pawneeDashModules = this.pawneeDashModules.filter(x => !(x === PaymentDashComponent));
    }

    if (!this.appGlobals.site?.paymentsActive || (!this.currentUser.hasPermissions('eodread') && !this.isAdmin())) {
      this.pawneeDashConfs = this.pawneeDashConfs.filter(x => x.ModuleID !== EodDashComponent.moduleID);
      this.pawneeDashModules = this.pawneeDashModules.filter(x => !(x === EodDashComponent));
    }

    // Remove Contract Dash for SITE inactive
    if (!this.appGlobals.site.contractAccountsActive) {
      this.pawneeDashConfs = this.pawneeDashConfs.filter(x => x.ModuleID !== KioskDashComponent.moduleID);
      this.pawneeDashModules = this.pawneeDashModules.filter(x => x["moduleID"] !== KioskDashComponent.moduleID);
    }

    if (this.appGlobals.site.enableMultiLocations) {
      this.subscriptionArray.push(this.appGlobals.locationChangedEmitter.subscribe(_ => {
        this.overlaySvc.enableOverlay();

        this.sthDashModule.clearDatesAndFilter();
        this.sthDashModule.dataService.forceAllDataStale();
        this.sthDashModule.dataService.triggerRefresh();

        this.invoiceDashModule.clearFilters();
        this.invoiceDashModule.dataService.forceAllDataStale();
        this.invoiceDashModule.dataService.triggerRefresh();

        this.paymentDashModule.clearDatesAndFilter();
        this.paymentDashModule.dataService.forceStaleData();
        this.paymentDashModule.dataService.triggerRefresh();

        this.eodDashModule.clearDatesAndFilter();
        this.eodDashModule.dataService.forceStaleData();
        this.eodDashModule.dataService.triggerRefresh();

        this.statusDashModule.refreshData();

        setTimeout(() => {
          this.overlaySvc.disableOverlay();
          this.cd.detectChanges();
        }, 1500);
      }));
    }

    this.contactDashModule.cd.markForCheck();
    this.booted = true;
  }


  private getModuleByName(name: string): object {
    if (name === ContactDashComponent.moduleID) {
      return ContactDashComponent;
    } else if (name === ScaleTicketHeaderDashComponent.moduleID) {
      return ScaleTicketHeaderDashComponent;
    } else if (name === JobDashComponent.moduleID) {
      return JobDashComponent;
    } else if (name === InvoiceDashComponent.moduleID) {
      return InvoiceDashComponent;
    } else if (name === VehicleDashComponent.moduleID) {
      return VehicleDashComponent;
    } else if (name === StatusDashComponent.moduleID) {
      return StatusDashComponent;
    } else if (name === KioskDashComponent.moduleID) {
      return KioskDashComponent;
    } else if (name === PaymentDashComponent.moduleID) {
      return PaymentDashComponent;
    } else if (name === EodDashComponent.moduleID) {
      return EodDashComponent
    } else {
      throw new Error(`Dash Module Reference: name not recognized. (${name})`);
    }
  }

  changeDashOrder(newIndex: number, oldIndex: number) {
    const movingModule = this.pawneeDashModules[oldIndex];
    this.pawneeDashModules.splice(oldIndex, 1);
    this.pawneeDashModules.splice(newIndex, 0, movingModule);

    this.saveDashModulesConfigs();
  }

  private saveDashModulesConfigs(): void {
    const confsToSave = [];
    const moduleOrderToSave = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let c = 0; c < this.pawneeDashConfs.length; c++) {
      confsToSave.push(this.buildDashConfSave(this.pawneeDashConfs[c]));
      moduleOrderToSave.push(this.pawneeDashConfs[c].ModuleID);
    }

    this.appGlobals.setDashConf({ modules: moduleOrderToSave, confs: confsToSave });
  }

  saveDashConfig(conf: DashConf): void {
    if (conf.moduleID === ContactDashComponent.moduleID && (conf as ContactDashConf).searchFilters) {
      this.appGlobals.setSearchSettings((conf as ContactDashConf).searchFilters, 'contacts');
    }

    this.pawneeDashConfs.find(x => x.dashConf.moduleID === conf.moduleID).dashConf = conf;
    this.saveDashModulesConfigs();
  }

  private buildDashConfSave(conf: DashModuleBase<any>): DashConfSave {
    const result = new DashConfSave(conf.boxTitle, conf.ModuleID, conf.boxMainIconClass);
    result.boxMainColor = conf.boxMainColor;
    result.hotKey = conf.hotKey;
    result.maximized = conf.startMaximized;
    result.minimized = conf.startMinimized;
    result.rpp = conf.recordLimit;
    if (conf.dashConf) {
      result.fontSize = conf.dashConf.fontSize > 0 && conf.dashConf.fontSize < 6 ? conf.dashConf.fontSize : 3;
      result.zebraStripe = conf.dashConf.zebraStripe;
      result.stickyMode = conf.dashConf.stickyMode;
    }

    return result;
  }

  switchTheme(themeSelection: IDashTheme) {
    this.theme = themeSelection;
    this.appGlobals.setDashTheme(themeSelection);
    this.cd.detectChanges();
  }

  public openVoucherAccountsPane () {
    this.overlaySvc.enableOverlay();
    this.voucherPaneOpen = true;
  }

  editVoucherAccount(contact: STContact, v: VoucherAccount, manageUsersMode = false) {
    this.voucherPaneEditMode = manageUsersMode? VoucherPaneMode.EditAuthorizedUsersForVoucher : VoucherPaneMode.EditVoucher;
    this.voucherPaneEditWithContact = contact;
    this.voucherPaneEditWithVoucher = v;
    this.openVoucherAccountsPane();
  }

  public closeVoucherAccountsPane () {
    this.voucherPaneOpen = false;
    this.overlaySvc.disableOverlay();

    // When navigating away from the voucher dashboard, return to location that opened that pane. (Contact pane)
    if (
        this.voucherPaneEditMode == VoucherPaneMode.CreateNewVoucherForContact ||
        this.voucherPaneEditMode == VoucherPaneMode.EditAuthorizedUsersForVoucher ||
        this.voucherPaneEditMode == VoucherPaneMode.EditVoucher
      ) {
      this.contactPaneHandle.closePane();
      this.contactDashSvc.forceAllDataStale();
      this.contactDashModule.refreshData();
      this.overlaySvc.enableOverlay();
      this.cd.detectChanges();

      setTimeout(() => {
        this.openRecordType(this.voucherPaneEditWithContact);
        this.voucherPaneEditMode = VoucherPaneMode.DashboardView;
        this.voucherPaneEditWithContact = null;
        this.voucherPaneEditWithVoucher = null;

        setTimeout(() => {
          let icon = "";
          // Update contact pane tabs to ensure voucher tab is active
          this.contactPaneTabs = this.contactPaneTabs.map(tab => {
            if (tab.name === "Contact_Voucher_Tab") {
              tab.active = true;
              icon = tab.iconClass;
            } else tab.active= false;
            return tab;
          });

          // Search for voucher tab button on contact pane and click it. This opens the proper navigation tab
          const ticketIcons = document.getElementsByClassName(icon);
          for(let i = 0; i < ticketIcons.length; i++) {
            const iconEl = ticketIcons[i];
            const parent = iconEl.parentElement;
            if (parent.tagName.toLowerCase() === "div" && parent.classList.contains("tabItem") && typeof parent["click"] === "function") {
              parent["click"]();
              break;
            }
          }
        }, 1500); // large delay to ensure buttons are clickable
      }, 750); // slight delay to ensure data refresh complete
    } else { // reset all fields so open dash works as expected
        this.voucherPaneEditMode = VoucherPaneMode.DashboardView;
        this.voucherPaneEditWithContact = null;
        this.voucherPaneEditWithVoucher = null;
    }
  }

  updateDashColor(cmd: { dash: string, data: any }) {
    if (!cmd.data) {
      return;
    }
    if (cmd.dash === this.contactDashModule.boxTitle) {
      this.contactDashModule.boxMainColor = cmd.data;
    } else if (cmd.dash === this.jobDashModule.boxTitle) {
      this.jobDashModule.boxMainColor = cmd.data;
    } else if (cmd.dash === this.kioskDashModule.boxTitle) {
      this.kioskDashModule.boxMainColor = cmd.data;
    } else if (cmd.dash === this.sthDashModule.boxTitle) {
      this.sthDashModule.boxMainColor = cmd.data;
    } else if (cmd.dash === this.vehicleDashModule.boxTitle) {
      this.vehicleDashModule.boxMainColor = cmd.data;
    } else if (cmd.dash === this.invoiceDashModule.boxTitle) {
      this.invoiceDashModule.boxMainColor = cmd.data;
    } else if (cmd.dash === this.statusDashModule.boxTitle) {
      this.statusDashModule.boxMainColor = cmd.data;
    } else if (cmd.dash === this.paymentDashModule.boxTitle) {
      this.paymentDashModule.boxMainColor = cmd.data;
    } else if (cmd.dash === this.paymentDashModule.boxTitle) {
      this.eodDashModule.boxMainColor = cmd.data;
    }
    this.saveDashModulesConfigs();
  }

  closeRateSchedules() {
    this.viewRateSchedules = false;
    this.jobDashSvc.triggerRefresh();
    this.contactDashSvc.triggerRefresh();
    if (this.jobPaneHandle.isPaneOpen || this.contactPaneHandle.isPaneOpen) {
      this.overlaySvc.disableOverlay();
      this.overlaySvc.enableOverlay();
    }
    else {
      this.overlaySvc.disableOverlay();
    }
  }

  openRSModal(rsHeader: RateScheduleHeader) {
    this.overlaySvc.disableOverlay();
    this.rateHeader = rsHeader;
    this.viewRateSchedules = true;
    this.overlaySvc.enableOverlay();
  }

  showError() {
    this.modalSvc.postModal(new StarbaseModalOptions('Error', 'This feature is only available for customers'));
  }

  updateClientRS(rs: RateScheduleHeader) {
    const index = this.arrayOfCustomerContactUIDs.findIndex(x => x.cuid === rs.contactContactUID);

    if (index >= 0) {
      this.arrayOfCustomerContactUIDs[index].rs = rs;
    }
  }

  deleteClientRS(cuid: string) {
    const cuidNValue = parseInt(cuid, 10);
    const index = this.arrayOfCustomerContactUIDs.findIndex(x => x.cuid === cuidNValue);

    if (index >= 0) {
      this.arrayOfCustomerContactUIDs[index].rs = null;
    }
  }

  checkIfContactIsCustomer(contact: ContactModel): boolean {
    if (contact.contactTypes.length) {
      return contact.contactTypes.some(x => x.lU_ContactType.contactTypeDescription.toLowerCase() === this.CUSTOMER_BADGE_VALUE);
    }
    return false;
  }

  getCustomerRateSchedule(contactUID: number, success: any, error: any = null) {
    this.rateSvc.contactUID = contactUID;
    this.rateSvc.getCustomerRateScheduleHeaders().subscribe(success, error);
  }

  viewCustomerRateSchedule(contact: STContact) {
    this.getCustomerRateSchedule(contact.contactUID, (rsHeaders: RateScheduleHeader[]) => {
      let rs = new RateScheduleHeader();
      if (rsHeaders.length > 0) {
        rs = rsHeaders[0];
      } else {
        rs.uid = 0;
      }

      rs.contactContactUID = contact.contactUID;
      rs.contact = contact;

      this.openRSModal(rs);
    }, () => this.showError());
  }

  getJobRateSchedule(jobUID: number, success: any, error: any = null) {
    this.rateSvc.jobUID = jobUID;
    this.rateSvc.getJobRateScheduleHeaders().subscribe(success, error, () => this.cd.markForCheck());
  }

  viewJobRateSchedule(job) {
    this.getJobRateSchedule(job.uid, (rsHeaders: RateScheduleHeader[]) => {
      let rs = new RateScheduleHeader();
      if (rsHeaders.length > 0) {
        rs = rsHeaders[0];
      } else {
        rs.uid = 0;
      }

      rs.jobUID = job.uid;
      rs.job = job;

      this.openRSModal(rs);
    }, () => this.showError());
  }

  /** Open a record pane of a specific type */
  openRecordType(record: object): void {
    // eslint-disable-next-line @typescript-eslint/dot-notation

    if (record instanceof ContactModel) {
      this.phoneLoaded = false;
      this.emailLoaded = false;
      // eslint-disable-next-line @typescript-eslint/dot-notation
      const contactUID = record['contactUID'];
      this.contactPaneHandle.singlePaneData = record;

      if (this.checkIfContactIsCustomer(record as STContact)) {
        const crecord = this.arrayOfCustomerContactUIDs.find(x => x.cuid === contactUID);
        var r = record as STContact
        this.contactDebtLimitInput = r.ticketCreditMax.toFixed(2);
        if (!crecord) {
          this.getCustomerRateSchedule(contactUID, (rsa: RateScheduleHeader[]) => {
            const item = {
              cuid: contactUID,
              isClient: true,
              rs: null
            };

            if (rsa.length > 0) {
              item.rs = rsa[0];
            }

            this.arrayOfCustomerContactUIDs.push(item);
          });
        }
      }

      this.contactPhoneSvc.currentContactId = contactUID;
      this.contactPhoneSvc.currentContactObj = record as ContactModel;
      this.contactEmailSvc.currentContactId = contactUID;
      this.contactEmailSvc.currentContactObj = record as ContactModel;
      this.overlaySvc.enableOverlay();
      this.setCustomContactPaneTabs();
      this.contactPaneHandle.openPane();
      if (this.contactPhonesTable) {
        this.contactPhonesTable.loadData();
        this.phoneLoaded = true;
      }

      else {
        setTimeout(() => {
          if (this.contactPhonesTable?.loadData) {
            this.contactPhonesTable.loadData();
            this.phoneLoaded = true;
            this.cd.detectChanges();
          }
        }, 2500);
      }
      if (this.contactEmailsTable) { this.contactEmailsTable.loadData(); this.emailLoaded = true }
      else {
        setTimeout(() => {
          if (this.contactEmailsTable?.loadData) {
            this.contactEmailsTable.loadData();
            this.emailLoaded = true;
            this.cd.detectChanges();
          }
        }, 2500);
      }
    } else if (record instanceof Job) {
      this.overlaySvc.enableOverlay();
      this.jobPaneHandle.openPane(record);
    } else if (record instanceof ScaleTicketHeader || this.checkIfRecordIsScaleTicketHeaderFromFilterParamCollection(record)) {
      this.overlaySvc.enableOverlay();
      this.scaleTicketPaneHandle.openPane(record as ScaleTicketHeader);
    } else if (record instanceof Vehicle) {
      this.overlaySvc.enableOverlay();
      this.vehiclePaneHandle.addMode = false;
      this.vehiclePaneHandle.editMode = false;
      this.vehiclePaneHandle.openPane(record);
    } else if (record instanceof AutomatedAccount) {
      this.overlaySvc.enableOverlay();
      this.kioskPaneHandle.addMode = false;
      this.kioskPaneHandle.editMode = false;
      this.vehicleToAddToContractAcc = null;
      this.kioskPaneHandle.openPane(record);
    } else if (record instanceof Payment) {
      this.overlaySvc.enableOverlay();
      this.prepayMode = record.invoices?.length == 0 ? true : false;
      this.hideACHPaymentOption = !this.prepayMode;
      this.paymentPaneHandle.addMode = false;
      this.paymentPaneHandle.editMode = false;
      this.paymentPaneHandle.openPane(record);
    }

    this.overlaySvc.enableOverlay();
  }

  checkIfRSExists(record: STContact) {
    const crecord = this.arrayOfCustomerContactUIDs.find(x => x.cuid === record.contactUID);
    return crecord !== null && crecord !== undefined;
  }

  // Only to be used if the record is coming from the filterParamsURI meaning it is actually in the correct shape of a ScaleTicketHeader but would
  // FAIL the check for record instanceof ScaleTicketHeader
  checkIfRecordIsScaleTicketHeaderFromFilterParamCollection(record: any): boolean {
    const requiredFields = [
      "scaleTicketType",
      "vehicle",
      "grid",
      "details",
      "scaleTicketStatus"
    ];

    return requiredFields.every(field => record[field] !== null && record[field] !== undefined);
  }


  newRecordHandler(dashTitle: string) {
    this.resetCurrentContactInServices();
    if (dashTitle === this.contactDashModule.boxTitle) {
      this.createContactWizOpen = true;
      this.overlaySvc.enableOverlay();
    } else if (dashTitle === this.jobDashModule.boxTitle) {
      const newJob = new Job();
      newJob.uid = 0;
      newJob.active = true;
      newJob.jobContactUID = 0;
      newJob.siteUID = 0;
      newJob.jobCodeUID = 0;
      newJob.jobCategoryUID = 0;
      newJob.jobDescription = '';
      newJob.jobStartDate = new Date();
      this.overlaySvc.enableOverlay();
      this.jobPaneHandle.openPane(newJob);
    } else if (dashTitle === this.vehicleDashModule.boxTitle) {
      const newVehicle = new Vehicle();
      newVehicle.contact = new STContact();
      newVehicle.active = true;
      this.vehiclePaneHandle.addMode = true;
      this.vehiclePaneHandle.editMode = false;
      this.vehiclePaneHandle.specialMode = false;
      this.overlaySvc.enableOverlay();
      this.vehiclePaneHandle.openPane(newVehicle);
    } else if (dashTitle === this.kioskDashModule.boxTitle) {
      const newKioskAccount = new AutomatedAccount();
      newKioskAccount.active = true;
      this.kioskPaneHandle.addMode = true;
      this.kioskPaneHandle.editMode = false;
      this.kioskPaneHandle.specialMode = false;
      this.vehicleToAddToContractAcc = null;
      this.overlaySvc.enableOverlay();
      this.kioskPaneHandle.openPane(newKioskAccount);
    } else if (dashTitle === this.sthDashModule.boxTitle) {
      this.launchScaleTicketWizard();
    } else if (dashTitle === this.invoiceDashModule.boxTitle) {
      this.launchInvoiceWizard();
    } else if (dashTitle === this.eodDashModule.boxTitle) {
      this.launchEODWizard();
    } else if (dashTitle === this.paymentDashModule.boxTitle) {
      this.launchPaymentWizard();
    } else {
      const titles = this.pawneeDashConfs.map(x => x.boxTitle);

      if (titles.find(x => x === dashTitle).length === 0) {
        console.error('New record type not recognized.');
      }
    }
  }


  updateActiveContactUID(uid: number): void {
    this.contactDashSvc.getData(this.contactDashSvc.getOneUri, uid, 0).subscribe(
      cust => this.openRecordType(new STContact().deserialize(cust)),
      () => {
        const c = new STContact();
        c.contactUID = uid;
        c.uid = uid;
        this.openRecordType(c);
      }
    );
  }


  private setCustomContactPaneTabs(): void {
    let tabsToUse = defaultContactTabs;
    tabsToUse = tabsToUse.filter(t => t.title !== 'Correspondences');
    this.contactPaneTabs = [
      ...tabsToUse,
      {
        name: 'Pawnee_Custom',
        title: 'Customer Details',
        template: this.pawneeCustomPane,
        iconClass: 'fa-clipboard',
        elementID: 'pawneeCustomTemplate',
        active: false
      }
    ];

    if (this.appGlobals.site?.voucherSystem !== VoucherSystemEnum.NONE) {
      this.contactPaneTabs.push({
        name: 'Contact_Voucher_Tab',
        title: 'Vouchers',
        template: this.contactVoucherTab,
        iconClass: 'fa-ticket-alt',
        elementID: 'contactVoucherTab',
        active: false
      });
    }
  }

  createNewVoucherRecordWithContact(contact: STContact) {
    this.voucherPaneEditMode = VoucherPaneMode.CreateNewVoucherForContact;
    this.voucherPaneEditWithContact = contact;
    this.openVoucherAccountsPane();
  }

  public contactVoucherIDTooltip(){
    return this.appGlobals.site.voucherIdentificationType === 0 ? "Drivers License #" : "Voucher ID";
  }

  public contactVoucherAUTooltip(voucher: VoucherAccount) {
    return voucher.authorizedUsers.map(v => `[${v.voucherID}] ${v.firstName}, ${v.lastName}`).join(" | ");
  }

  private resetCurrentContactInServices(): void {
    this.contactPhoneSvc.currentContactId = 0;
    this.contactPhoneSvc.currentContactObj = new STContact();
    this.contactEmailSvc.currentContactId = 0;
    this.contactEmailSvc.currentContactObj = new STContact();
  }

  private newEntityModal(
    entityName: string,
    modalTemplate: TemplateRef<any>,
    enableButtonCondition?: () => boolean): Observable<boolean> {
    const btnSubject = new Subject<boolean>();
    const goBtn = new StarbaseModalButton(
      'Go',
      () => {
        this.modalSvc.closeModal(`User proceeded with new ${entityName}.`);
        this.overlaySvc.enableOverlay(); // enable overlay for the pane
        btnSubject.next(true); // open the specified pane
      },
      enableButtonCondition
    );
    const cancelBtn = new StarbaseModalButton(
      'Cancel',
      () => {
        this.modalSvc.closeModal(`User cancelled new ${entityName}.`);
        btnSubject.next(false);
      }
    );
    this.modalSvc.postModal(
      new StarbaseModalOptions(
        `Create New ${entityName}`,
        '',
        [
          goBtn,
          cancelBtn
        ],
        StarbaseModalTypes.Success,
        modalTemplate
      )
    );
    return btnSubject;
  }

  private createNewContact(): ContactModel {
    const c = {
      individual: true, // will be overridable by the newContact modal
      contactUID: 0,
      uid: 0,
      lastName: '',
      organization: '',
      active: true
    };
    return new ContactModel().deserialize(c);
  }

  closePane(dashTitle: string): void {
    if (dashTitle === this.contactDashModule.boxTitle) {
      this.contactPaneHandle.closePane();
    } else if (dashTitle === this.vehicleDashModule.boxTitle) {
      this.vehiclePaneHandle.closePane();
    } else if (dashTitle === this.sthDashModule.boxTitle) {
      this.scaleTicketPaneHandle.closePane();
    } else if (dashTitle === this.vehicleDashModule.boxTitle) {
      this.vehiclePaneHandle.addMode = false;
      this.vehiclePaneHandle.editMode = false;
      this.vehiclePaneHandle.closePane();
    } else if (dashTitle === this.kioskDashModule.boxTitle) {
      this.kioskPaneHandle.addMode = false;
      this.kioskPaneHandle.editMode = false;
      this.kioskPaneHandle.closePane();
    } else if (dashTitle === this.jobDashModule.boxTitle) {
      this.jobPaneHandle.closePane();
    } else if (dashTitle === this.paymentDashModule.boxTitle) {
      this.paymentPaneHandle.closePane();
      this.prepayMode = false;
      this.hideACHPaymentOption = false;
    }
    this.overlaySvc.disableOverlay();
  }

  /* .... Deletion confirmation section.... */

  deleteContact(c: ContactModel) {
    const yesBtn = new StarbaseModalButton('Delete forever', () => {
      this.contactDashSvc.deleteData(this.contactDashSvc.deleteUri, c.uid.toString()).subscribe(
        () => {
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Contact Deleted',
              'The contact record and associated data have been erased.',
              StarbaseNotificationTypes.Notice));
          this.contactPaneHandle.closePane();
          this.contactDashModule.refreshData();
        },
        () => this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Deletion Failed',
            `Sorry, the action did not complete. \n
              You cannot delete contacts that have any linked data in the system.`,
            StarbaseNotificationTypes.Error)),
        () => {
          this.modalSvc.closeModal('User clicked yes');
          this.contactDashSvc.triggerRefresh();
        }
      );
    });
    const noBtn = new StarbaseModalButton('Cancel', () => {
      this.modalSvc.closeModal('User cancelled');
    });

    this.modalSvc.postModal(
      new StarbaseModalOptions('Delete Contact?',
        `Are you sure you want to permanently erase
          \n\n ${c.getDisplayName()}? \n\n
          This cannot be undone!`,
        [yesBtn, noBtn],
        StarbaseModalTypes.Warning)
    );
  }

  /* ....End deletion confirmation section.... */

  deactivateDataConfirm(event: { title: string, msg: string, obs: Subject<boolean> }) {
    this.modalSvc.postModal(
      new StarbaseModalOptions(
        event.title,
        event.msg,
        [
          new StarbaseModalButton(
            'Proceed',
            () => {
              event.obs.next(true);
              this.modalSvc.closeModal('User pressed proceed');
            }
          ),
          new StarbaseModalButton(
            'Cancel',
            () => {
              event.obs.next(false);
              this.modalSvc.closeModal('User cancelled');
            }
          )
        ],
        StarbaseModalTypes.Warning
      ));
  }

  handleShareContact(contact: ContactModel): void {
    this.sbCmpMsgSvc.handleStarbaseComponentMsg(
      new StarbaseComponentMessage(
        `clipboard::Contact::${location.origin}/
        fullScreenContact/${contact.contactUID}`,
        true));
  }

  public handleDashComponentMsg(msg: IMessage) {
    if (msg.quiet) {
      this.handleMessageCommands(msg);
      return;
    }

    const theNotification = this.notiSvc.notificationBuilder('Message from Dashboard ', msg.message);
    if (msg.error) {
      theNotification.type = StarbaseNotificationTypes.Error;
      theNotification.duration = 7500;
    } else if (msg.success) {
      theNotification.type = StarbaseNotificationTypes.Success;
      theNotification.duration = 4000;
    } else if (msg.warning) {
      theNotification.type = StarbaseNotificationTypes.Warning;
      theNotification.duration = 7000;
    }

    this.notiSvc.postNotification(theNotification);

    if (msg.message.includes('birthday')) {
      if (this.appGlobals.getStoredBirthdayNoticeSetting()) {
        theNotification.type = StarbaseNotificationTypes.Info;
        theNotification.duration = 7000;
      } else { return; } // don't show bday notification if the option is turned off.
    }
  }

  private handleMessageCommands(msg: IMessage): void {
    if (msg.message === 'ContactDashComponent minimized') { // TODO: Adapt to the new way in Starbase Dashboard.component when it's done
      this.contactDashModule.startMinimized = true;
      this.contactDashModule.startMaximized = false;
    } else if (msg.message === 'ContactDashComponent restored') {
      this.contactDashModule.startMinimized = false;
      this.contactDashModule.startMaximized = false;
    } else if (msg.message === 'ContactDashComponent maximized') {
      this.contactDashModule.startMaximized = true;
      this.contactDashModule.startMinimized = false;

    } else if (msg.message === 'Scale Ticket Dash minimized') {
      this.sthDashModule.startMinimized = true;
    } else if (msg.message === 'Scale Ticket Dash restored') {
      this.sthDashModule.startMaximized = false;
      this.sthDashModule.startMinimized = false;
    } else if (msg.message === 'Scale Ticket Dash maximized') {
      this.sthDashModule.startMaximized = true;
      this.sthDashModule.startMinimized = false;

    } else if (msg.message === 'Jobs Dash minimized') {
      this.jobDashModule.startMinimized = true;
    } else if (msg.message === 'Jobs Dash restored') {
      this.jobDashModule.startMinimized = false;
      this.jobDashModule.startMaximized = false;
    } else if (msg.message === 'Jobs Dash maximized') {
      this.jobDashModule.startMaximized = true;
      this.jobDashModule.startMinimized = false;

    } else if (msg.message === 'Invoices Dash minimized') {
      this.invoiceDashModule.startMinimized = true;
    } else if (msg.message === 'Invoices Dash restored') {
      this.invoiceDashModule.startMaximized = false;
      this.invoiceDashModule.startMinimized = false;
    } else if (msg.message === 'Invoices Dash maximized') {
      this.invoiceDashModule.startMaximized = true;
      this.invoiceDashModule.startMinimized = false;

    } else if (msg.message === 'StatusDash minimized') {
      this.statusDashModule.startMinimized = true;
      this.statusDashModule.startMaximized = false;
    } else if (msg.message === 'StatusDash restored') {
      this.statusDashModule.startMaximized = false;
      this.statusDashModule.startMinimized = false;
    } else if (msg.message === 'StatusDash maximized') {
      this.statusDashModule.startMaximized = true;
      this.statusDashModule.startMinimized = false;

    } else if (msg.message === 'Kiosk Dash minimized') {
      this.kioskDashModule.startMinimized = true;
    } else if (msg.message === 'Kiosk Dash restored') {
      this.kioskDashModule.startMaximized = false;
      this.kioskDashModule.startMinimized = false;
    } else if (msg.message === 'Kiosk Dash maximized') {
      this.kioskDashModule.startMaximized = true;
      this.kioskDashModule.startMinimized = false;

    } else if (msg.message === 'Vehicle Dash minimized') {
      this.vehicleDashModule.startMinimized = true;
    } else if (msg.message === 'Vehicle Dash restored') {
      this.vehicleDashModule.startMaximized = false;
      this.vehicleDashModule.startMinimized = false;
    } else if (msg.message === 'Vehicle Dash maximized') {
      this.vehicleDashModule.startMaximized = true;
      this.vehicleDashModule.startMinimized = false;

    } else if (msg.message === 'PaymentDashModule minimized') {
      this.paymentDashModule.startMinimized = true;
    } else if (msg.message === 'PaymentDashModule restored') {
      this.paymentDashModule.startMaximized = false;
      this.paymentDashModule.startMinimized = false;
    } else if (msg.message === 'PaymentDashModule maximized') {
      this.paymentDashModule.startMaximized = true;
      this.paymentDashModule.startMinimized = false;

    } else if (msg.message === 'EODBatchDash minimized') {
      this.eodDashModule.startMinimized = true;
    } else if (msg.message === 'EODBatchDash restored') {
      this.eodDashModule.startMaximized = false;
      this.eodDashModule.startMinimized = false;
    } else if (msg.message === 'EODBatchDash maximized') {
      this.eodDashModule.startMaximized = true;
      this.eodDashModule.startMinimized = false;

    } else if (msg.message === 'KioskDash minimized') {
      this.kioskDashModule.startMinimized = true;
    } else if (msg.message === 'KioskDash restored') {
      this.kioskDashModule.startMaximized = false;
      this.kioskDashModule.startMinimized = false;
    } else if (msg.message === 'KioskDash maximized') {
      this.kioskDashModule.startMaximized = true;
      this.kioskDashModule.startMinimized = false;
    }

    this.saveDashModulesConfigs();
  }

  scrollToMenu(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  focusOnDash(dashBoxTitle: string) {
    document
      .querySelector(`#${dashBoxTitle.replace(' ', '')}box`)
      .scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  private registerHotkeyEvents() {
    this.unregisterHotkeyEvents();
    // Register Hotkeys For pulling specific scale into form-input aswell as selecting active scale
    // Remove hotkey handlings
    const handler = (ev: KeyboardEvent) => {
      if (ev.altKey && ev.key == "t") {
        this.focusOnDash(this.sthDashModule.boxTitle);
      } else if (ev.altKey && ev.key == "i" && !this.currentUser.hasPermissions('invoiceread')) {
        this.focusOnDash(this.invoiceDashModule.boxTitle);
      } else if (ev.altKey && ev.key == "p" && !this.currentUser.hasPermissions('paymentread')) {
        this.focusOnDash(this.paymentDashModule.boxTitle);
      } else if (ev.altKey && ev.key == "b" && !this.currentUser.hasPermissions('paymentread')) {
        this.focusOnDash(this.eodDashModule.boxTitle);
      } else if (ev.altKey && ev.key == "v" && !this.currentUser.hasPermissions('vehicleread')) {
        this.focusOnDash(this.vehicleDashModule.boxTitle);
      } else if (ev.altKey && ev.key == "j" && !this.currentUser.hasPermissions('jobread')) {
        this.focusOnDash(this.jobDashModule.boxTitle);
      } else if (ev.altKey && ev.key == "c" && !this.currentUser.hasPermissions('contactsread')) {
        this.focusOnDash(this.contactDashModule.boxTitle);
      } else if (ev.altKey && ev.key == "x") {
        this.focusOnDash(this.statusDashModule.boxTitle);
      } else if (ev.altKey && ev.key == "k") {
        this.focusOnDash(this.kioskDashModule.boxTitle);
      }
    }
    document.addEventListener("keydown", handler, true);
    this.removeHotkeyListener = () => document.removeEventListener("keydown", handler);
  }

  private unregisterHotkeyEvents() {
    if (this.removeHotkeyListener) {
      this.removeHotkeyListener();
    }
  }

  openDashOptions() {
    const dashOptionsModal =
      new StarbaseModalOptions(
        'Customize Your Dashboard',
        '',
        [],
        StarbaseModalTypes.Notice,
        this.dashModalTemplate
      );

    dashOptionsModal.forcedWidth = '620px';
    this.modalSvc.postModal(
      dashOptionsModal
    );

    let subscription: Subscription;
    subscription = this.modalSvc.modalEmitter.subscribe(v => {
      this.showDashboard = false;
      this.cd.markForCheck();
      subscription.unsubscribe();
      setTimeout(() => {
        this.showDashboard = true;
        this.cd.detectChanges();
      }, 500);
    });
  }

  /** Function for User Management */
  manageUser(user: UserAccountModel = null) {
    if (user) {
      this.editUserId = user.uid;
      this.managingContact = true;
    }
    const modalOptions = new StarbaseModalOptions(
      'Manage User',
      '',
      [
        new StarbaseModalButton(
          'Okay',
          user ?
            () => {
              this.setCustomContactPaneTabs();
              this.modalSvc.closeModal('User Clicked Okay');
              this.overlaySvc.enableOverlay();
              this.contactPaneHandle.openPane();
              this.managingContact = false;
            } :
            () => {
              this.modalSvc.closeModal('User Clicked Okay');
            }
        )
      ],
      StarbaseModalTypes.Info,
      this.editUserModalTemplate
    );
    modalOptions.forcedWidth = '1100px';
    this.contactPaneHandle.closePane();
    this.overlaySvc.disableOverlay();
    this.modalSvc.postModal(modalOptions);
  }

  refreshUserToken() {
    this.userSvc.refreshUserToken().subscribe(token => {
      const res = this.loginSvc.processToken(token);
      if (res.success) {
        window.location.reload();
      }
    })
  }

  checkPasswordScore = (pwd: string): Observable<PasswordScoreEnum> => {
    return this.userSvc.checkPasswordScore(pwd, { site : this.appGlobals.site.sequence }).pipe(
      debounceTime(1000),
      map(s => s as PasswordScoreEnum)
    );
 }

  checkEmailTaken = (email: string) => this.userSvc.getRequisiteData(this.userSvc.UsernameAllowedUri + email).pipe(
    debounceTime(1000)
  )

  handleRecordHistoryRequest(guid: string) {
    if (!guid || guid === '') {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Unknown entity',
          'Sorry, record history is not available for that entity.',
          StarbaseNotificationTypes.Notice
        )
      );
      return;
    }
    const fp = new FilterParams<STLog>();
    fp.rpp = 10;
    fp.addToFilter('EntityGuid', guid);
    this.logSvc.getDataByFilterParamsBroadSearch(this.logSvc.broadSearchUri, fp).subscribe(d => {
      this.logSvc.setLastRetrievedEntityName((d.collection.length) ? d.collection[0].entityName : '');
      this.modalSvc.closeModal('Requested History');
      this.appComponent.recordHistoryData = d;
      this.modalSvc.postModal(new StarbaseModalOptions(
        'Record History',
        '',
        [
          new StarbaseModalButton(
            'Back',
            () => {
              this.modalSvc.closeModal('User Clicked Back');
              const modalOptions = new StarbaseModalOptions(
                'Manage User',
                '',
                [
                  new StarbaseModalButton(
                    'Okay',
                    this.managingContact ?
                      () => {
                        this.modalSvc.closeModal('User Clicked Okay');
                        this.overlaySvc.enableOverlay();
                        this.contactPaneHandle.openPane();
                        this.managingContact = false;
                      } :
                      () => {
                        this.modalSvc.closeModal('User Clicked Okay');
                      }
                  )
                ],
                StarbaseModalTypes.Info,
                this.editUserModalTemplate
              );
              modalOptions.forcedWidth = '1100px';
              this.modalSvc.postModal(modalOptions);
            }
          )
        ],
        StarbaseModalTypes.Info,
        this.appComponent.recordHistoryModalTemplate
      ));
    });
  }

  promoteContactToUser(contact: STContact) {
    this.contactPaneHandle.closePane();
    this.overlaySvc.disableOverlay();
    this.promoteContact = contact;
    this.createContactUserMode = true;
    this.createContactWizOpen = true;
    this.overlaySvc.enableOverlay();
  }

  openCreateContactWizard() {
    this.createContactUserMode = true;
    this.createContactWizOpen = true;
    this.overlaySvc.enableOverlay();
  }

  closeContactWizard(data: undefined | string | ContactModel) {
    this.createContactWizOpen = false;
    this.createContactUserMode = false;
    if (data === undefined) {
      if (this.promoteContact) {
        this.promoteContact = null;
        this.overlaySvc.enableOverlay();
        this.contactPaneHandle.openPane();
      }
    } else if (data instanceof ContactModel) {
      this.openRecordType(data);
      if (data.organization) {
        this.jobDashSvc.triggerRefresh();
      }
    } else {
      this.cd.detectChanges();
      this.newRecordHandler(data);
    }
  }

  handleCreateContactWizardCompleted(user: UserAccountModel) {
    user.userGroups.forEach(
      (gl) => {
        gl.userGroup = null;
      }
    );
    // eslint-disable-next-line @typescript-eslint/dot-notation
    user['phoneNumber'] = null;
    if (user.contact.commTypesPhone[0] && user.contact.commTypesPhone[0].phoneNumber === '') {
      user.contact.commTypesPhone = [];
    }
    this.userSvc.postData(this.userSvc.postUri, user).subscribe(
      (u: UserAccountModel) => {
        this.notiSvc.postNotification(this.notiSvc.notificationBuilder('Success', 'User Account Successfully Created', null, 7500, StarbaseNotificationSentiment.Success));
        this.createContactWithUserWizOpen = false;
        this.overlaySvc.disableOverlay();
      },
      (e) => {
        this.notiSvc.postNotification(this.notiSvc.notificationBuilder('Error', 'Failed to Create New User', null, 7500, StarbaseNotificationSentiment.Success));
        this.createContactWithUserWizOpen = false;
        this.overlaySvc.disableOverlay();
      }
    );
    if (this.promoteContact) {
      this.promoteContact = null;
      this.overlaySvc.enableOverlay();
      this.contactPaneHandle.openPane();
    }
  }

  handleCreateContactWizardCancelled() {
    this.promoteContact = null;
    this.createContactWithUserWizOpen = false;
    this.overlaySvc.disableOverlay();
  }

  prepContactWizard() {
    this.cd.detectChanges();

    // prep new contact steps
    this.standardContactWizSteps = this.createContactWizard.defaultCreateContactSteps;

    this.isCustomerWizSteps = this.standardContactWizSteps.map(x => Object.assign({}, x));

    this.isCustomerWizSteps.splice(4, 0, new StarbaseWizardStep(
      'Customer Info',
      this.customerStep,
      'auto'
    ));

    this.isCustomerWizSteps[4].stepFormGroup = this.fb.group({
      certofInsuranceRequired: new FormControl(this.createContactWizard.newContact.certofInsuranceRequired),
      certOfInsuranceExpDate: new FormControl(this.createContactWizard.newContact.certOfInsuranceExpDate),
      materialsTestRequired: new FormControl(this.createContactWizard.newContact.materialsTestRequired),
      materialsTestExpDate: new FormControl(this.createContactWizard.newContact.materialsTestExpDate),
      showTicketRatesOnInvoice: new FormControl(this.createContactWizard.newContact.showTicketRatesOnInvoice),
      saExecutedDate: new FormControl(this.createContactWizard.newContact.saExecutedDate),
      customerPaymentMethod: new FormControl(this.createContactWizard.newContact.customerPaymentMethod,
        { validators: [Validators.required] })
    });

    // eslint-disable-next-line @typescript-eslint/dot-notation
    this.isCustomerWizSteps[4].stepFormGroup.controls['customerPaymentMethod'].setValue(CustomerPaymentMethodEnum.ON_ACCOUNT);
    // eslint-disable-next-line @typescript-eslint/dot-notation
    this.isCustomerWizSteps[4].stepFormGroup.controls['certofInsuranceRequired'].setValue(false);
    // eslint-disable-next-line @typescript-eslint/dot-notation
    this.isCustomerWizSteps[4].stepFormGroup.controls['materialsTestRequired'].setValue(false);
    // eslint-disable-next-line @typescript-eslint/dot-notation
    this.isCustomerWizSteps[4].stepFormGroup.controls['showTicketRatesOnInvoice'].setValue(true);

    this.isCustomerWizSteps[1].interStepFunc = this.standardContactWizSteps[1].interStepFunc = (x: STContact) => {
      if (this.checkIfContactIsCustomer(this.createContactWizard.createContactWizard.currentObject)) {
        this.createContactWizard.createContactWizardSteps = this.isCustomerWizSteps;
        this.createContactWizard.createContactWizard.currentObject.certofInsuranceRequired = false;
        this.createContactWizard.createContactWizard.currentObject.materialsTestRequired = false;
        this.createContactWizard.createContactWizard.currentObject.showTicketRatesOnInvoice = true;
        this.customerDefaultJob = new Job();
        this.customerDefaultJob.jobDescription = this.createContactWizard.createContactWizard.currentObject.organization + ' - Default Job';
        this.customerDefaultJob.generatorName = '';
        this.customerDefaultJob.manifestNameRequired = false;
        this.customerDefaultJob.manifestRequired = false;
        this.customerDefaultJob.wasteProfileRequired = false;
        this.customerDefaultJob.invoiceFieldApprovalRequired = false;
        this.customerDefaultJob.useAutomaticScale = false;
        this.customerDefaultJob.siteUID = this.appGlobals.site.uid;
        this.addDefaultJob = true;
        this.createContactWizard.createContactWizard.detectChanges();
      } else {
        this.createContactWizard.createContactWizardSteps = this.standardContactWizSteps;
        this.addDefaultJob = false;
        this.createContactWizard.createContactWizard.detectChanges();
      }
      this.standardContactWizSteps[2].stepValidationFunc(x);
      return of(void 0);
    };

    this.isCustomerWizSteps[3].interStepFunc = (x: STContact) => {
      this.isCustomerWizSteps[4].stepValidationFunc(x);
      return of(void 0);
    };

    this.createContactWizard.createContactWizardSteps = this.standardContactWizSteps;
  }

  updateJobCategoryRecord() {
    this.customerDefaultJob.jobCategory = this.jobCategories.find(x => x.uid === this.customerDefaultJob.jobCategoryUID);
  }

  updateJobCodeRecord() {
    this.customerDefaultJob.jobCode = this.jobCodes.find(x => x.uid === this.customerDefaultJob.jobCodeUID);
  }

  changeReq(requireControl: FormControl, dateControl: FormControl, value: boolean) {
    if (value) {
      dateControl.setValidators(Validators.required);
    } else {
      dateControl.clearValidators();
    }
    dateControl.updateValueAndValidity();
    this.createContactWizard.createContactWizard.checkCurrentStepValidity();
  }

  changeVal(control: FormControl, val: any) {
    control.setValue(val);
    control.updateValueAndValidity();
    this.createContactWizard.createContactWizard.checkCurrentStepValidity();
  }

  handleContactWizard(contact?: STContact, restart?: boolean) {
    if (contact) {
      contact.commTypesPhone.map(p => p.smsSuffix = 'Unknown');
      this.contactDashSvc.postData(this.contactDashSvc.postUri, contact).subscribe(
        (data) => {
          this.createContactWizOpen = false;
          if (this.addDefaultJob && this.customerDefaultJob) {
            this.customerDefaultJob.jobContactUID = data.contactUid;
            this.jobDashSvc.postData(this.jobDashSvc.postUri, this.customerDefaultJob).subscribe(
              (job) => {
                this.customerDefaultJob = undefined;
                this.addDefaultJob = false;
              },
              (e) => {
                console.error(e);
                this.notiSvc.postNotification(
                  this.notiSvc.notificationBuilder(
                    'Error',
                    'Failed to save new contact record.',
                    StarbaseNotificationTypes.Error
                  )
                );
                this.customerDefaultJob = undefined;
                this.addDefaultJob = false;
              }
            )
          }
          this.cd.detectChanges();
          this.overlaySvc.disableOverlay();
          if (restart) {
            this.newRecordHandler(this.contactDashModule.boxTitle);
          } else {
            const contactModel = Object.assign(new ContactModel(), data);
            this.openRecordType(contactModel);
          }
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Success',
              'Successfully created new contact record.',
              StarbaseNotificationTypes.Success
            )
          );
          this.contactDashSvc.triggerRefresh();
        },
        (e) => {
          console.error(e);
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Error',
              'Failed to save new contact record.',
              StarbaseNotificationTypes.Error
            )
          );
          this.createContactWizOpen = false;
          this.overlaySvc.disableOverlay();
        }
      );
    } else {
      this.createContactWizOpen = false;
      this.overlaySvc.disableOverlay();
    }
  }

  // launchKioskAccountWizard() {
  //   this.overlaySvc.enableOverlay();
  //   this.createKioskAccountWizOpen = true;
  // }

  // handleKioskAccountWizard(obj) {
  //   this.createKioskAccountWizOpen = false;
  //   this.overlaySvc.disableOverlay();

  //   if (obj) {
  //     this.createNewKioskAccountRecord(obj);
  //   }
  // }

  launchScaleTicketWizard() {
    this.overlaySvc.enableOverlay();
    this.createScaleTicketWizOpen = true;
  }

  handleScaleTicketWizard(obj) {
    this.createScaleTicketWizOpen = false;
    this.overlaySvc.disableOverlay();

    if (obj) {
      this.createNewScaleTicketRecord(obj);
    }
  }

  launchScaleTicketPreScreen(vehicle?: Vehicle) {
    this.overlaySvc.enableOverlay();
    this.prescreenMemo = false;
    this.scaleticketPreScreenOpen = true;
    this.preScreenOpenWithVehicle = vehicle ?? null;
  }

  launchCreditMemoPreScreen(vehicle?: Vehicle) {
    this.overlaySvc.enableOverlay();
    this.prescreenMemo = true;
    this.scaleticketPreScreenOpen = true;
    this.preScreenOpenWithVehicle = vehicle ?? null;
  }

  handleScaleTicketPreScreen(obj) {
    this.scaleticketPreScreenOpen = false;
    this.overlaySvc.disableOverlay();

    if (obj) {
      this.createNewScaleTicketRecord(obj);
    }
  }

  launchReportPreScreen() {
    this.overlaySvc.enableOverlay();
    this.reportPreScreenOpen = true;
  }
  handleReportPreScreen(obj) {
    this.reportPreScreenOpen = false;
    this.overlaySvc.disableOverlay();

    if (obj) {
      //this.createNewScaleTicketRecord(obj);
    }
  }
  handleIsCustBool() {

  }

  createNewScaleTicketRecord(data?: ScaleTicketHeader): void {
    const newSth = data || new ScaleTicketHeader();
    if (!data) {
      newSth.uid = 0;
      newSth.scaleTicketStatus = ScaleTicketStatusEnum.WAITING_ROOM;
      newSth.scaleTicketDateIn = newSth.scaleTicketDateOut = new Date();
    }
    this.sbSvcProvider.overlaySvc.enableOverlay();
    this.scaleTicketPaneHandle.openPane(newSth);
  }

  createNewKioskAccountRecord(data?: AutomatedAccount): void {
    const newSth = data || new AutomatedAccount();
    if (!data) {
      newSth.uid = 0;
    }

    this.sbSvcProvider.overlaySvc.enableOverlay();
    // this.scaleTicketPaneHandle.openPane(newSth);
  }

  launchInvoiceWizard() {
    this.sbSvcProvider.overlaySvc.enableOverlay();
    this.createInvoiceWizOpen = true;
  }

  handleInvoiceWizard(obj) {
    if (obj) {
      this.createNewInvoiceRecord(obj);
    }
    this.createInvoiceWizOpen = false;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  launchInvoiceBatchWizard() {
    this.sbSvcProvider.overlaySvc.enableOverlay();
    this.createInvoiceBatchWizOpen = true;
  }

  handleInvoiceBatchWizard(batch: LU_InvoiceBatch) {
    if (batch) {
      const invoices: InvoiceUpload[] = [];
      batch.invoices.forEach(i => invoices.push(new InvoiceUpload(i)));
      this.invoiceUploadBatch = invoices;
      this.invoiceBatch = batch;
      this.createInvoiceBatchWizOpen = false;
      this.batchUploaderOpen = true;
      this.cd.detectChanges();
    } else {
      this.createInvoiceBatchWizOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    }
  }

  batchUploadCompleted() {
    this.batchUploaderOpen = false;
    this.sbSvcProvider.overlaySvc.disableOverlay();
    this.sthSvc.triggerRefresh();
    this.invoiceSvc.triggerRefresh();
    this.cd.detectChanges();
  }

  createNewInvoiceRecord(data?: Invoice): void {
    // Trim unnecessary data for post
    data.job = null;
    data.customer = null;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < data.scaleTickets.length; ++i) {
      data.scaleTickets[i].job = null;
      data.scaleTickets[i].rollOff = null;
      data.scaleTickets[i].vehicle = null;
      data.scaleTickets[i].grid = null;
      data.scaleTickets[i].scaleTicketStatusDisp = null;
      data.scaleTickets[i].weighmaster = null;
    }

    this.isGenerating = true;
    this.cd.detectChanges();
    this.invoiceSvc.postData(this.invoiceSvc.postUri, data).subscribe(
      (invoice) => {
        if (data.selectedEmails && data.selectedEmails.length > 0) {
          const emailInvoice$ = this.invoiceSvc.emailInvoice(invoice.uid, invoice).pipe(share());
          const notifier = this.createAsyncNotification(emailInvoice$);
          emailInvoice$.subscribe(() => {
            notifier.updateTitle('Success');
            notifier.updateContent('Invoice successfully created');
            this.isGenerating = false;
            this.cd.detectChanges();
            this.invoiceSvc.triggerRefresh();
          },
            (e) => {
              console.error(e);
              notifier.updateTitle('Error');
              notifier.updateContent('Failed to email Invoice data.');
              this.isGenerating = false;
              this.cd.detectChanges();
            });
          this.sbSvcProvider.notificationSvc.postNotification(notifier);
        } else {
          const genInvoice$ = this.invoiceSvc.generateInvoice(invoice.uid, false).pipe(share());
          const notifier = this.createAsyncNotification(genInvoice$);
          genInvoice$.subscribe(
            () => {
              this.isGenerating = false;
              this.cd.detectChanges();
              notifier.updateTitle('Success');
              notifier.updateContent('Invoice successfully created');
            },
            (e) => {
              notifier.updateTitle('Error');
              notifier.updateContent('Failed to generate Invoice.');
              console.error(e);
              this.isGenerating = false;
              this.cd.detectChanges();
            }
          );
          this.sbSvcProvider.notificationSvc.postNotification(notifier);
        }
        this.sthSvc.triggerRefresh();
        this.invoiceSvc.triggerRefresh();
      },
      (e) => {
        console.error(e);
        this.isGenerating = false;
        this.cd.detectChanges();
        this.sbSvcProvider.notificationSvc.postNotification(this.sbSvcProvider.notificationSvc.notificationBuilder(
          'Error',
          'Failed to create invoice',
          StarbaseNotificationTypes.Error
        ));
      }
    );
  }

  createNewInvoiceForPayment(data?: Payment): void {
    // Trim unnecessary data for post
    data.invoices[0].job = null;
    data.invoices[0].customer = null;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < data.invoices[0].scaleTickets.length; ++i) {
      data.invoices[0].scaleTickets[i].job = null;
      data.invoices[0].scaleTickets[i].rollOff = null;
      data.invoices[0].scaleTickets[i].vehicle = null;
      data.invoices[0].scaleTickets[i].grid = null;
      data.invoices[0].scaleTickets[i].scaleTicketStatusDisp = null;
      data.invoices[0].scaleTickets[i].weighmaster = null;
    }

    data.invoices[0].status = InvoiceStatusEnum.APPROVED;
    this.isGenerating = true;
    this.cd.detectChanges();
    this.invoiceSvc.postData(this.invoiceSvc.postUri, data.invoices[0]).subscribe((invoice) => {
      this.sthSvc.triggerRefresh();
      this.invoiceSvc.triggerRefresh();
      data.invoices[0] = invoice;
      data.paymentLinks[0].invoice = invoice;
      data.paymentLinks[0].invoiceUID = invoice.uid;
      this.createNewPaymentRecord(data);
    },
      (e) => {
        console.error(e);

        this.isGenerating = false;
        this.cd.detectChanges();
        this.sbSvcProvider.notificationSvc.postNotification(this.sbSvcProvider.notificationSvc.notificationBuilder(
          'Error',
          'Failed to create invoice',
          StarbaseNotificationTypes.Error
        ));

        this.hideACHPaymentOption = this.stMode = this.invMode = this.prepayMode = false;
      }
    );
  }

  private createAsyncNotification(obs: Observable<any>): IStarbaseNotificationObject {
    let title = 'Please wait...';
    if (this.isDownloading) {
      title = 'Downloading...';
    } else if (this.isGenerating) {
      title = 'Processing...';
    }
    return this.sbSvcProvider.notificationSvc.notificationBuilderAsync(
      title,
      null,
      StarbaseNotificationTypes.Notice, // or set undefined and 5th param = StarbaseNotificationSentiment.Notice
      obs
    );
  }

  launchCopyRateScheduleWizard(rate: RateScheduleHeader) {
    this.rateHeader = rate;
    this.copyRateWizOpen = true;
  }

  handleCopyRateScheduleWizard(obj) {
    this.copyRateWizOpen = false;

    this.jobDashSvc.triggerRefresh();
    this.contactDashSvc.triggerRefresh();
    if (obj) {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Success',
          'Rate Schedule Successfully Copied',
          StarbaseNotificationTypes.Success
        )
      );
    } else {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Error',
          'Failed to Copy Rate Schedule',
          StarbaseNotificationTypes.Error
        )
      );
    }
  }

  cancelCopyRateScheduleWizard(obj) {
    this.copyRateWizOpen = false;
  }

  stdTimezoneOffset(date) {
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }

  isDstObserved() {
    const date = new Date();
    return date.getTimezoneOffset() < this.stdTimezoneOffset(date);
  }

  deleteUser(id: number): void {
    this.enableConfirmationModal('Are you sure you want to remove this user account?',
      'User Account Removed',
      'User Account Not Removed').subscribe((a: boolean) => {
        if (a === true) {
          this.userSvc.deleteData(this.userSvc.deleteUri, id)
            .subscribe(() => {
              this.notiSvc.postNotification(this.notiSvc.notificationBuilder('Success',
                'User Account Removed Successfully', StarbaseNotificationTypes.Success));
              this.invoiceSvc.triggerRefresh();
            }, (err) => {
              this.notiSvc.postNotification(this.notiSvc.notificationBuilder('Error',
                'Failed to Remove User Account',
                StarbaseNotificationTypes.Error));
            });
        }
      }, () => {
        this.notiSvc.postNotification(this.notiSvc.notificationBuilder('Error',
          'Could Not Remove User Account',
          StarbaseNotificationTypes.Error));
      });
  }

  enableConfirmationModal(msg: string, successmsg?: string, errormsg?: string): Observable<boolean> {
    const m = new Observable<boolean>(obj => {
      const modal = new StarbaseModalOptions('Confirm', msg, [
        new StarbaseModalButton('Yes', () => {
          obj.next(true);
          this.modalSvc.closeModal(successmsg);
        }),
        new StarbaseModalButton('No', () => {
          obj.next(false);
          this.modalSvc.closeModal(errormsg);
        }),
      ], StarbaseModalTypes.Warning);
      modal.dismissable = true;
      this.modalSvc.postModal(modal);
    });

    return m;
  }

  contactUpdateConfirm(event: { title: string, msg: string, obs: Subject<boolean> }) {
    this.modalSvc.postModal(
      new StarbaseModalOptions(
        event.title,
        event.msg,
        [
          new StarbaseModalButton(
            'Continue',
            () => {
              event.obs.next(true);
              this.modalSvc.closeModal('User pressed continue');
            }
          )
        ],
        StarbaseModalTypes.Warning
      ));
  }

  contactUpdated() {
    this.notiSvc.postNotification(
      this.notiSvc.notificationBuilder(
        'Contact Updated',
        'This Contact record has been updated by another user.',
        StarbaseNotificationTypes.Info
      )
    );
  }

  private exportContactExcel(filters: FilterParams<STContact>) {
    if (!this.isDownloading) {
      this.isDownloading = true;
      const jobExcel$ = this.contactDashSvc.getContactsExcel(filters).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        jobExcel$);
      jobExcel$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          // eslint-disable-next-line max-len
          downLink.setAttribute('download', `Contacts Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.xlsx`);
          downLink.click();
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Excel report successfully generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          notifier.updateContent('Failed to download Excel report.');
        }
      );
      this.notiSvc.postNotification(notifier);
    }
  }

  private exportCustomContactReport(data: { report: string, filters: FilterParams<ContactModel> }) {
    switch (data.report) {
      case 'AccCredit':
        this.exportAccountCreditReport(data.filters as FilterParams<STContact>);
        break;
      case 'CSBatch':
        this.openCustomerSelect();
        break;
    }
  }

  private exportAccountCreditReport(filters: FilterParams<STContact>) {
    if (!this.isDownloading) {
      this.isDownloading = true;
      const jobExcel$ = this.contactDashSvc.getAccountCreditPDF(filters).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        jobExcel$);
      jobExcel$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          // eslint-disable-next-line max-len
          downLink.setAttribute('download', `Account Credit Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Account Credit report successfully generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          notifier.updateContent('Failed to download Account Credit report.');
        }
      );
      this.notiSvc.postNotification(notifier);
    }
  }

  /** Receives a message command from the Dashboard component
   * and handles interpreting what type of message needs to be sent
   * then hands off control to the appropriate function.
   */
  interceptMessageCommand(data: [ContactModel, ICommType][]) {
    if (!data.length || !data[0].length) {
      console.warn('No Comm Type data received. Canceling action.');
      return false;
    }
    if (data[0][0] instanceof ContactModel) {
      this.receiveSendMessage(data as [ContactModel, ICommType][]);
    } else {
      console.warn('Send Message command received from dash module, but could not be interpreted.');
    }
  }

  receiveSendMessage(data: [ContactModel, ICommType][]) {
    let recipients = '';
    if (data.length === 1) {
      this.sendMessageToContact(data[0][0], data[0][1]);
    } else {
      for (const m of data) {
        recipients += m[1].getCommAddress() + ',';
      }
      this.sendingEmailAddress = recipients.slice(0, -1);
      const sendModal = new StarbaseModalOptions(
        `Send an email to ${data.length} contacts`,
        ``,
        [],
        StarbaseModalTypes.Info,
        this.sendEmailModal
      );
      const sendBtn = new StarbaseModalButton(' Send',
        () => {
          const emailBody = this.textForEmail.nativeElement.value;
          const subject = this.subjectForEmail.nativeElement.value;
          if (emailBody === '') {
            this.notiSvc.postNotification(
              this.notiSvc.notificationBuilder('Email Message Required',
                'Please enter a message in your email.', undefined, 4500,
                StarbaseNotificationSentiment.Warning));
          } else {
            sendModal.working = true;
            this.contactDashSvc.postRequisiteData(
              this.contactDashSvc.sendMassEmailUri,
              { recipientIDs: data.map((d => d[0].contactUID)), body: emailBody, subject }
            ).subscribe(
              () => {
                this.notiSvc.postNotification(
                  this.notiSvc.notificationBuilder(
                    'Email Sent!',
                    `Your messages were sent.`,
                    undefined, 4250,
                    StarbaseNotificationSentiment.Success));
                this.modalSvc.closeModal('User pressed Send. Process succeeded.');
              },
              e => {
                this.notiSvc.postNotification(
                  this.notiSvc.notificationBuilder(
                    'Email failed.', 'Your messages could not be sent.',
                    undefined, 4250,
                    StarbaseNotificationSentiment.Error));
                console.error(e);
                sendModal.working = false;
              }
            );
          }
        });
      const cancelBtn = new StarbaseModalButton('Cancel',
        () => {
          this.modalSvc.closeModal('User pressed cancel');
        });

      sendModal.buttons = [sendBtn, cancelBtn];
      this.modalSvc.postModal(sendModal);
    }
  }

  sendMessageToContact(contact: ContactModel, comm: ICommType) {
    this.sendingEmailTo = contact;
    this.sendingEmailAddress = comm.getCommAddress();
    const sendModal = new StarbaseModalOptions(
      `Send an email to ${contact.getDisplayName()}`,
      ``,
      [],
      StarbaseModalTypes.Info,
      this.sendEmailModal
    );
    const sendBtn = new StarbaseModalButton(' Send',
      () => {
        const emailBody = `${this.currentLoggedInUser.userName} says: ${this.textForEmail.nativeElement.value}`;
        const subject = this.subjectForEmail.nativeElement.value;
        if (emailBody === '') {
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder('Email Message Required',
              'Please enter a message body before sending your email.', undefined, 4500,
              StarbaseNotificationSentiment.Warning));
        } else {
          sendModal.working = true;
          this.sendActualEmail(contact, subject, emailBody, sendModal);
        }
      });
    const cancelBtn = new StarbaseModalButton('Cancel',
      () => {
        this.modalSvc.closeModal('User pressed cancel');
      });

    sendModal.buttons = [sendBtn, cancelBtn];
    this.modalSvc.postModal(sendModal);
  }

  // Actually does the task of sending a Starbase Msg.
  private sendActualEmail(contact: ContactModel, subject: string, emailBody: string, modalContext?: StarbaseModalOptions) {
    this.contactDashSvc.postRequisiteData(
      `${this.contactDashSvc.sendEmailToContactUri}${contact.uid.toString()}&subject=${subject}`,
      `"${emailBody}"`
    ).subscribe(
      () => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Email Sent!',
            `Your message was sent to ${contact.getDisplayName()}`,
            undefined, 4250,
            StarbaseNotificationSentiment.Success));
        modalContext.closeModal('User pressed Send. Process succeeded.');
        if (this.modalSvc.isCurrentlyModal()) {
          this.modalSvc.closeModal('User pressed Send. Process succeeded.');
        }
      },
      e => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Email Unhappy.', 'Your message could not be sent.',
            undefined, 4250,
            StarbaseNotificationSentiment.Error));
        console.error(e);
        // eslint-disable-next-line curly
        if (modalContext) modalContext.working = false;
      }
    );
  }

  generatePaymentForST(paymentDataFromWizard: Payment): void {
    if (!paymentDataFromWizard?.invoices?.length) {
      this.sbSvcProvider.notificationSvc.postNotification(
        this.sbSvcProvider.notificationSvc.notificationBuilder(
          'Error',
          'Cannot process payment. Invoice data is missing from the wizard output.',
          StarbaseNotificationTypes.Error
        )
      );

      this.isGenerating = false;
      this.hideACHPaymentOption = this.stMode = this.invMode = this.prepayMode = false;
      return;
    }

    this.isGenerating = true;
    this.cd.detectChanges();
    const originalPaymentDataForRetry = new Payment().deserialize(JSON.parse(JSON.stringify(paymentDataFromWizard)));

    const invoiceToProcessForAPI = new Invoice().deserialize(JSON.parse(JSON.stringify(paymentDataFromWizard.invoices[0])));
    invoiceToProcessForAPI.status = InvoiceStatusEnum.APPROVED;
    invoiceToProcessForAPI.job = null;
    invoiceToProcessForAPI.customer = null;

    if (invoiceToProcessForAPI.scaleTickets) {
      invoiceToProcessForAPI.scaleTickets.forEach(st => {
        st.job = null;
        st.rollOff = null;
        st.vehicle = null;
        st.grid = null;
        st.scaleTicketStatusDisp = null;
        st.weighmaster = null;
      });
    }

    const paymentToProcessForAPI = new Payment().deserialize(JSON.parse(JSON.stringify(paymentDataFromWizard))) as Payment;
    paymentToProcessForAPI.customer = null;
    paymentToProcessForAPI.invoices = paymentToProcessForAPI.invoices.map(inv => ({ uid: inv.uid } as Invoice));
    paymentToProcessForAPI.voucherAccountUID = paymentDataFromWizard.voucherAccountUID;
    paymentToProcessForAPI.voucherAccount = paymentDataFromWizard.voucherAccount ? paymentDataFromWizard.voucherAccount : null;
    paymentToProcessForAPI.voucherUsed = paymentToProcessForAPI.voucherUsed;

    if (paymentToProcessForAPI.paymentLinks) {
      paymentToProcessForAPI.paymentLinks.forEach(pl => pl.invoice = null);
    }

    if (this.appGlobals.site.enableMultiLocations && this.appGlobals.selectedLocation) {
      paymentToProcessForAPI.locationUID = this.appGlobals.selectedLocation.uid;
      invoiceToProcessForAPI.locationUID = this.appGlobals.selectedLocation.uid;
    }

    const payload: InvoicePaymentModel = {
      invoice: invoiceToProcessForAPI,
      payment: paymentToProcessForAPI
    };

    const paymentProcessing$ = this.invoiceSvc.createInvoiceAndPayment(payload).pipe(share());
    const notifier = new StarbaseNotificationObject(
      'Processing Payment...',
      'Please wait while we process your payment and create the invoice.',
      StarbaseNotificationSentiment.Notice,
      null,
      paymentProcessing$
    );

    this.sbSvcProvider.notificationSvc.postNotification(notifier);
    paymentProcessing$.subscribe((response: CreateInvoicePaymentResponseModel) => {
      this.isGenerating = false;
      this.cd.detectChanges();

      notifier.updateTitle('Success');
      notifier.updateContent('Invoice and Payment processed successfully!');

      this.paymentForRetry = new Payment().deserialize(JSON.parse(JSON.stringify(originalPaymentDataForRetry)));
      this.paymentForRetry.uid = response.paymentUID;
      this.paymentForRetry.paymentNumber = response.paymentNumber;

      if (this.paymentForRetry.invoices?.length > 0) {
        const invoiceInRetry = this.paymentForRetry.invoices[0];
        invoiceInRetry.uid = response.invoiceUID;
        invoiceInRetry.invoiceNumber = response.invoiceNumber;
        invoiceInRetry.status = InvoiceStatusEnum.PAID;
      } else if (originalPaymentDataForRetry.invoices?.length > 0) {
        const newInvoiceFromResponse = new Invoice().deserialize(JSON.parse(JSON.stringify(originalPaymentDataForRetry.invoices[0])));
        newInvoiceFromResponse.uid = response.invoiceUID;
        newInvoiceFromResponse.invoiceNumber = response.invoiceNumber;
        newInvoiceFromResponse.status = InvoiceStatusEnum.PAID;
        this.paymentForRetry.invoices = [newInvoiceFromResponse];
      }

      if (this.paymentForRetry.paymentLinks?.length > 0) {
        this.paymentForRetry.paymentLinks.forEach(pl => {
          pl.invoiceUID = response.invoiceUID;
          if (pl.invoice) {
            pl.invoice.uid = response.invoiceUID;
            pl.invoice.invoiceNumber = response.invoiceNumber;
            pl.invoice.status = InvoiceStatusEnum.PAID;
          } else {
            const originalLinkData = originalPaymentDataForRetry.paymentLinks.find(
              origLink => (origLink.uid && origLink.uid === pl.uid) ||
                (!origLink.uid && pl.invoiceUID === originalPaymentDataForRetry.invoices[0]?.uid && origLink.paymentAmount === pl.paymentAmount)
            );

            if (originalLinkData?.invoice) {
              pl.invoice = new Invoice().deserialize(JSON.parse(JSON.stringify(originalLinkData.invoice)));
              pl.invoice.uid = response.invoiceUID;
              pl.invoice.invoiceNumber = response.invoiceNumber;
              pl.invoice.status = InvoiceStatusEnum.PAID;
            } else {
              pl.invoice = new Invoice().deserialize({
                uid: response.invoiceUID,
                invoiceNumber: response.invoiceNumber,
                status: InvoiceStatusEnum.PAID
              });
            }
          }
        });
      }

      this.payment = this.paymentForRetry;
      this.hideACHPaymentOption = this.stMode = this.invMode = false;
      this.sthSvc.triggerRefresh();
      this.invoiceSvc.triggerRefresh();
      this.paymentSvc.triggerRefresh();

      if (this.appGlobals.site.paymentSystem === PaymentSystemEnum.CLOVER && this.paymentForRetry?.uid) {
        this.paymentSvc.sendCardPaymentToProcessor(this.paymentForRetry.uid).subscribe(
          (id) => { if (id) this.payPendSvc.PaymentNowPending(); },
          () => {
            this.errorSendingPayment = true;
            this.sbSvcProvider.notificationSvc.postNotification(
              this.sbSvcProvider.notificationSvc.notificationBuilder('Error', 'Error Sending Payment to Processor after successful record creation.', StarbaseNotificationTypes.Error)
            );

            this.payPendSvc.PaymentSendingFailedTrigger$.next(null);
            setTimeout(() => { this.errorSendingPayment = false; }, 3000);
          }
        );
      }

      if (this.appGlobals.site.paymentSystem === PaymentSystemEnum.FORTE && this.paymentForRetry?.uid && (this.paymentForRetry.achAmount > 0 || this.paymentForRetry.cardAmount > 0)) {
          this.hideACHPaymentOption = this.stMode = this.invMode = this.prepayMode = false;
          //TODO: needs to be fixed to handle payments coming from the wizard that are not coming from the pane.
          if(this.scaleTicketPaneHandle.isPaneOpen) {
            this.scaleTicketPaneHandle.closePane();
          }
          setTimeout(() => {
            this.overlaySvc.disableOverlay();
            this.openRecordType(this.payment);
          }, 200);
      }

      if (!this.appGlobals.site.highEfficiencyMode && this.payment) {
        this.enablePaymentInfoModal('Hold On').subscribe();
      }
    }, (error) => {
      this.isGenerating = false;
      this.cd.detectChanges();

      notifier.updateTitle('Error');
      notifier.updateContent('Failed to process invoice and payment. Please try again.');

      this.sbSvcProvider.notificationSvc.postNotification(
        this.sbSvcProvider.notificationSvc.notificationBuilder(
          'Error',
          `Failed to process invoice and payment: ${error?.error?.message || error?.message || 'Please review details and try again.'}`,
          StarbaseNotificationTypes.Error
        )
      );

      console.error("Error in processCombinedInvoiceAndPayment:", error);

      this.paymentForRetry = originalPaymentDataForRetry;
      this.createPaymentWizOpen = true;
      this.overlaySvc.enableOverlay();
      this.cd.detectChanges();

      setTimeout(() => {
        if (this.paymentWizardRef && this.paymentForRetry) {
          this.paymentWizardRef.restoreStateAndNavigateToFinalStep(this.paymentForRetry);
        } else {
          console.warn('Payment wizard reference or retry data not available for restoring state.');
        }
      }, 0);
    }
    );
  }


  handlePaymentWizard(payment: Payment, stOverride?: boolean) {
    if (stOverride) {
      this.stMode = true;
      //TODO: turn off if this is not needed for clients
      this.closePane(this.sthDashModule.boxTitle)
    }

    this.createPaymentWizOpen = false;
    if (payment) {
      if (this.stMode) {
        //New API to do handle both, create invoice and make payment in the same request.
        this.generatePaymentForST(payment);
      }
      else {
        this.createNewPaymentRecord(payment);
      }
    } else {
      this.hideACHPaymentOption = this.stMode = this.invMode = false;
    }

    if (!this.scaleTicketPaneHandle.isPaneOpen) {
      this.sbSvcProvider.overlaySvc.disableOverlay();
    }
  }

  createNewPaymentRecord(data?: Payment): void {
    this.isGenerating = true;
    data.voucherAccount = null;
    if (this.appGlobals.site.enableMultiLocations && this.appGlobals.selectedLocation) {
      data.locationUID = this.appGlobals.selectedLocation.uid;
    }

    this.paymentSvc.postData(this.paymentSvc.postUri, data).subscribe((payment: Payment) => {
      this.payment = payment;
      if (!this.prepayMode) {
        this.payment.invoices[0].scaleTickets = data.invoices[0].scaleTickets;
      }

      this.cd.detectChanges();
      this.sbSvcProvider.notificationSvc.postNotification(this.sbSvcProvider.notificationSvc.notificationBuilder('Success', 'Payment Successfully Created', StarbaseNotificationTypes.Success));
      if (this.stMode && !this.appGlobals.site.highEfficiencyMode) {
        this.enablePaymentInfoModal('Hold On').subscribe();
      }

      if (this.invMode) {
        this.sbSvcProvider.overlaySvc.disableOverlay();
      }

      if (this.stMode) {
        const genInvoice$ = this.invoiceSvc.generateInvoice(this.payment.invoices[0].uid, false).pipe(share());
        const notifier = this.createAsyncNotification(genInvoice$);
        genInvoice$.subscribe(() => {
          this.isGenerating = false;
          this.cd.detectChanges();
        }, (e) => {
          notifier.updateTitle('Error');
          notifier.updateContent('Failed to generate Invoice.');
          console.error(e);
          this.isGenerating = false;
          this.cd.detectChanges();
        });

        this.sbSvcProvider.notificationSvc.postNotification(notifier);
      }

      if (this.prepayMode) {
        this.sbSvcProvider.overlaySvc.disableOverlay();
      }

      this.sthSvc.triggerRefresh();
      this.invoiceSvc.triggerRefresh();
      this.paymentSvc.triggerRefresh();

      if (this.appGlobals.site.paymentSystem === PaymentSystemEnum.CLOVER) {
        this.paymentSvc.sendCardPaymentToProcessor(payment.uid).subscribe((id) => {
            if (id) {
              if (this.invMode) {
                this.openRecordType(new Payment().deserialize(this.payment));
              }

              this.payPendSvc.PaymentNowPending();
            }

            this.hideACHPaymentOption = this.stMode = this.invMode = this.prepayMode = false;
          },
          () => {
            this.errorSendingPayment = true;
            this.sbSvcProvider.notificationSvc.postNotification(this.sbSvcProvider.notificationSvc.notificationBuilder('Error','Error Sending Payment to Processor', StarbaseNotificationTypes.Error));

            if (this.invMode) {
              this.openRecordType(new Payment().deserialize(this.payment));
            } else {
              this.payPendSvc.PaymentSendingFailedTrigger$.next(null);
            }

            setTimeout(() => {
              this.errorSendingPayment = false;
            }, 3000);

            this.hideACHPaymentOption = this.stMode = this.invMode = this.prepayMode = false;
          });
      } else if (this.appGlobals.site.paymentSystem === PaymentSystemEnum.FORTE && (payment?.uid && (payment.cardAmount > 0 || payment.achAmount > 0))) {
          this.hideACHPaymentOption = this.stMode = this.invMode = this.prepayMode = false;
          this.scaleTicketPaneHandle.closePane();
          setTimeout(() => {
            this.overlaySvc.disableOverlay();
            this.openRecordType(new Payment().deserialize(this.payment));
          }, 200);
      } else {
        this.hideACHPaymentOption = this.stMode = this.invMode = this.prepayMode = false;
      }

      setTimeout(() => this.isGenerating = false, 10000);
    }, () => {
        this.sbSvcProvider.notificationSvc.postNotification(this.sbSvcProvider.notificationSvc.notificationBuilder('Error',
          'Error making Record ', StarbaseNotificationTypes.Error));
        this.isGenerating = false;
        this.hideACHPaymentOption = this.stMode = this.invMode = this.prepayMode = false;
        if (!this.scaleTicketPaneHandle.isPaneOpen) {
          this.sbSvcProvider.overlaySvc.disableOverlay();
        }
      }
    )

    this.createPaymentWizOpen = false;
    this.sthSvc.callPaymentWizardModal.next(null);
  }

  launchPaymentWizard(e?: any) {
    this.prepayMode = true;
    this.hideACHPaymentOption = false;
    this.sbSvcProvider.overlaySvc.enableOverlay();
    this.createPaymentWizOpen = true;
  }

  launchEODWizard() {
    this.sbSvcProvider.overlaySvc.enableOverlay();
    this.createEODWizOpen = true;
  }

  handleEODWizard(obj) {
    if (obj) {
      this.createNewEODRecord(obj);
    }

    this.createEODWizOpen = false;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  updateCustomerTerm(cont: STContact, id: number) {
    var ts = this.terms;
    var t = ts.filter(j => j.uid == id);
    cont.term = t[0]
    //this.setCustomContactPaneTabs();
  }

  updateApplyCharges(cont: STContact) {
    if (!cont.applyFinanceCharge) {
      cont.term = null;
    }
  }

  createNewEODRecord(data?: EODBatch): void {
    if (this.appGlobals.site.enableMultiLocations && this.appGlobals.selectedLocation) {
      data.locationUID = this.appGlobals.selectedLocation.uid;
    }

    this.isGenerating = true;
    const eod$ = this.eodBatchSvc.postEODBatch(this.eodBatchSvc.postUri, data).pipe(share());
    const notifier = this.createAsyncNotification(eod$);
    this.sbSvcProvider.notificationSvc.postNotification(notifier);

    eod$.subscribe((eod: EODBatch) => {
        this.cd.detectChanges();
        notifier.updateTitle('Success');
        notifier.updateContent('End of Day Batch Successfully Created');
        this.sthSvc.triggerRefresh();
        this.invoiceSvc.triggerRefresh();
        this.paymentSvc.triggerRefresh();
        this.eodBatchSvc.triggerRefresh();
        setTimeout(() => this.isGenerating = false, 10000);
      },
      () => {
        notifier.updateTitle('Error');
        notifier.updateContent('Error making Record');
        this.isGenerating = false;
      }
    );

    this.createEODWizOpen = false;
  }

  enablePaymentInfoModal(msg: string, successmsg?: string, errormsg?: string): Observable<boolean> {
    this.paymentSvc.getData(this.paymentSvc.getOneUri, this.payment.uid).subscribe(p => {
      this.payment.paymentNumber = p.paymentNumber;
    })

    this.cardTypes = Payment.GetCardTypesEnum();
    this.paymentTicketNumbers = "#" + this.payment.invoices[0].scaleTickets.map(st => st.scaleTicketNumber).join(', #');
    const m = new Observable<boolean>(obj => {
      const modal = new StarbaseModalOptions('Payment Completed', msg, [
        new StarbaseModalButton('Okay', () => {
          obj.next(true);
          this.sbSvcProvider.modalSvc.closeModal(successmsg);
          if (this.scaleTicketPaneHandle.isPaneOpen) {
            this.sbSvcProvider.overlaySvc.disableOverlay();
          }
        }),
      ], StarbaseModalTypes.Success, this.paymentInfoModal);
      modal.dismissable = false;
      this.sbSvcProvider.modalSvc.postModal(modal);
    });

    return m;
  }

  getCashDisplay(payment: Payment, value: number) {
    let cash = payment.cashAmount;
    let card = payment.cardAmount;
    let check = payment.checkAmount;
    let cashback = payment.cashBack;

    let amount = 0;

    switch (value) {
      case 1:
        amount = cash - cashback;
        break;
      case 2:
        amount = card + payment.cardSurchargeAmount;
        break;
      case 3:
        amount = check;
        break;
      case 4:
        amount = payment.totalAmountPaid > payment.totalAmountDue ? payment.totalAmountDue : payment.totalAmountPaid;
    }
    if (!amount && value === 1 && !(this.payment.totalAmountPaid > 0)) {
      return '0.00';
    } else if (!amount) {
      return '-';
    }
    return this.dp.transform(amount, '1.2-2');
  }

  customerStatement(cust: STContact, filterParam: FilterParams<Invoice>) {
    this.isDownloading = true;
    const genTicket$ = this.invoiceSvc.generateCustomerStatementPDF(cust.uid, true, filterParam).pipe(share());
    const notifier = new StarbaseNotificationObject(
      'Downloading...',
      null,
      StarbaseNotificationSentiment.Notice,
      null,
      genTicket$);
    genTicket$.subscribe(
      (content: any) => {
        const blob = new Blob([content], { type: 'application/pdf' });
        const downLink = document.createElement('a');
        downLink.href = window.URL.createObjectURL(blob);
        downLink.setAttribute('download', `Customer Statement ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
        downLink.click();
        window.open(downLink.href, '_blank');
        this.isDownloading = false;
        this.cd.detectChanges();
        notifier.updateTitle('Success');
        notifier.updateContent('Report Successfully Generated');
      },
      (e) => {
        console.error(e);
        this.isDownloading = false;
        this.cd.detectChanges();
        notifier.updateTitle('Error');
        if (e.status === 404) {
          notifier.updateContent('No Data to Report')
        }
        else {
          notifier.updateContent('Failed to Generate Report');
        }
      }
    );
    this.sbSvcProvider.notificationSvc.postNotification(notifier);
  }

  oneMonthCustomerStatement(cust: STContact) {
    var params = new FilterParams<Invoice>();
    var d1 = new Date()
    var d2 = new Date()
    d1.setMonth(d1.getMonth() - 1)
    d1.setDate(1)
    d1.setHours(0, 0, 0, 0);
    d2.setDate(0)
    d2.setHours(23, 59, 59, 999);
    params.addToFilter('InvoiceDateFrom', d1)
    params.addToFilter('InvoiceDateTo', d2)
    this.customerStatement(cust, params)
  }

  customCustomerStatement(cust: STContact) {
    this.customerStatementModalOpen = true;
    this.sbSvcProvider.overlaySvc.enableOverlay();
    this.statmentID = cust.uid
  }

  custInvoiceAgingDetail(cust: STContact) {
    if (!this.isDownloading) {
      this.isDownloading = true;
      const genTicket$ = this.invoiceSvc.generateAgingDetailReportPDF(cust.uid).pipe(share());
      //this.closeInvoiceAgingDetailDatePicker();
      const notifier = new StarbaseNotificationObject(
        'Downloading...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        genTicket$);
      genTicket$.subscribe(
        (content: any) => {
          const blob = new Blob([content], { type: 'application/pdf' });
          const downLink = document.createElement('a');
          downLink.href = window.URL.createObjectURL(blob);
          downLink.setAttribute('download', `Invoice Aging Detail Report ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
          downLink.click();
          window.open(downLink.href, '_blank');
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Success');
          notifier.updateContent('Report Successfully Generated');
        },
        (e) => {
          console.error(e);
          this.isDownloading = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          if (e.status === 404) {
            notifier.updateContent('No Data to Report')
          }
          else {
            notifier.updateContent('Failed to Generate Report');
          }
        }
      );
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
    }
  }

  closeCustomerStatement() {
    this.customerStatementModalOpen = false;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  showCustStatement() {
    this.isDownloading = true;
    var filterParam = new FilterParams<Invoice>();
    this.filterDateFrom ? filterParam.addToFilter('InvoiceDateFrom', this.filterDateFrom) : ''
    this.filterDateTo ? filterParam.addToFilter('InvoiceDateTo', this.filterDateTo) : ''
    const genTicket$ = this.invoiceSvc.generateCustomerStatementPDF(this.statmentID, true, filterParam).pipe(share());
    this.closeCustomerStatement();
    const notifier = new StarbaseNotificationObject(
      'Downloading...',
      null,
      StarbaseNotificationSentiment.Notice,
      null,
      genTicket$);
    genTicket$.subscribe(
      (content: any) => {
        const blob = new Blob([content], { type: 'application/pdf' });
        const downLink = document.createElement('a');
        downLink.href = window.URL.createObjectURL(blob);
        downLink.setAttribute('download', `Customer Statement ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
        downLink.click();
        window.open(downLink.href, '_blank');
        this.isDownloading = false;
        this.cd.detectChanges();
        notifier.updateTitle('Success');
        notifier.updateContent('Report Successfully Generated');
      },
      (e) => {
        console.error(e);
        this.isDownloading = false;
        this.cd.detectChanges();
        notifier.updateTitle('Error');
        if (e.status === 404) {
          notifier.updateContent('No Tickets In Date Range')
        }
        else {
          notifier.updateContent('Failed to Generate Report');
        }
      }
    );
    this.filterDateFrom = null;
    this.filterDateTo = null;
    this.statmentID = null;
    this.sbSvcProvider.notificationSvc.postNotification(notifier);
  }

  dateRangeChangeForInvoices(val: Date[]) {
    if (!val) {
      this.filterDateFrom = null;
      this.filterDateTo = null;
      //this.dateEntered = false;
    } else {
      this.filterDateFrom = val[0];
      this.filterDateTo = val[1];
      this.filterDateFrom.setHours(0, 0, 0, 0);
      this.filterDateTo.setHours(23, 59, 59, 999);
      //this.dateEntered = true;
    }
    return;
  }

  getCardTypeText(status: CardType) {
    switch (status) {
      case CardType.NONE: return '';
      case CardType.VISA: return 'VISA';
      case CardType.MASTER_CARD: return 'MASTER CARD';
      case CardType.AMEX: return 'AMEX';
      case CardType.OTHER: return 'OTHER';
      case CardType.DISCOVER: return 'DISCOVER'
    }
  }

  getMonthText(m: Number) {
    switch (m) {
      case 1: return "January";
      case 2: return "Febuary";
      case 3: return "March";
      case 4: return "April";
      case 5: return "May";
      case 6: return "June";
      case 7: return "July";
      case 8: return "August";
      case 9: return "September";
      case 10: return "October";
      case 11: return "November";
      case 0: return "December";
    }
  }

  termInactive(uid: number) {
    return !this.activeTerms.find(t => t.uid == uid);
  }

  openContractAccount(contractAccount: AutomatedAccount) {
    this.kioskPaneHandle.addMode = false;
    this.kioskPaneHandle.editMode = false;
    this.vehicleToAddToContractAcc = null;
    this.vehiclePaneHandle.closePane();
    this.overlaySvc.enableOverlay();
    this.kioskPaneHandle.openPane(contractAccount);
  }

  addVehicleToNewContractAccount(vehicle: Vehicle) {
    const newAcc = new AutomatedAccount();
    newAcc.active = true;
    this.kioskPaneHandle.addMode = true;
    this.kioskPaneHandle.editMode = false;
    this.kioskPaneHandle.specialMode = false;
    this.vehicleToAddToContractAcc = vehicle;
    this.vehiclePaneHandle.closePane();
    this.overlaySvc.enableOverlay();
    this.kioskPaneHandle.openPane(newAcc);
  }

  updateInputFields(cont: STContact) {
    if (this.contactDebtLimitInput[0] == "-") {
      this.contactDebtLimitInput = this.contactDebtLimitInput.slice(1, this.contactDebtLimitInput.length);
    }
    cont.ticketCreditMax = parseFloat(this.contactDebtLimitInput.replace(/,/g, ''));
  }

  customerHistory(cust: STContact) {
    this.customerHistoryModalOpen = true;
    this.sbSvcProvider.overlaySvc.enableOverlay();
    this.statmentID = cust.uid
  }

  showCustomerHistory() {
    this.isDownloading = true;
    var filterParam = new FilterParams<Invoice>();
    this.filterDateFrom ? filterParam.addToFilter('InvoiceDateFrom', this.filterDateFrom) : ''
    this.filterDateTo ? filterParam.addToFilter('InvoiceDateTo', this.filterDateTo) : ''
    const genTicket$ = this.invoiceSvc.generateCustomerHistoryPDF(this.statmentID, filterParam).pipe(share());
    this.closeCustomerHistory();
    const notifier = new StarbaseNotificationObject(
      'Downloading...',
      null,
      StarbaseNotificationSentiment.Notice,
      null,
      genTicket$);
    genTicket$.subscribe(
      (content: any) => {
        const blob = new Blob([content], { type: 'application/pdf' });
        const downLink = document.createElement('a');
        downLink.href = window.URL.createObjectURL(blob);
        downLink.setAttribute('download', `Customer Statement ${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd-HH-mm')}.pdf`);
        downLink.click();
        window.open(downLink.href, '_blank');
        this.isDownloading = false;
        this.cd.detectChanges();
        notifier.updateTitle('Success');
        notifier.updateContent('Report Successfully Generated');
      },
      (e) => {
        console.error(e);
        this.isDownloading = false;
        this.cd.detectChanges();
        notifier.updateTitle('Error');
        if (e.status === 404) {
          notifier.updateContent('No Tickets In Date Range')
        }
        else {
          notifier.updateContent('Failed to Generate Report');
        }
      }
    );
    this.filterDateFrom = null;
    this.filterDateTo = null;
    this.statmentID = null;
    this.sbSvcProvider.notificationSvc.postNotification(notifier);
  }

  closeCustomerHistory() {
    this.customerHistoryModalOpen = false;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  openEmailCustStatement(cust: STContact) {
    this.contactForStatement = cust;
    this.selectedEmails = [];
    this.contactEmailSvc.getPreferredEmail(cust.uid)
      .subscribe((c: STContactEmail[]) => {
        c.forEach((ce) => {
          ce.selected = true;
          ce.emailMethod = EmailMethodEnum.TO;
        });
        this.selectedEmails = c;
        this.contactEmailSvc.triggerRefresh();
        this.sbSvcProvider.overlaySvc.enableOverlay();
        this.emailSelectOpen = true;
        this.contactEmailSvc.triggerRefresh();
        this.cd.detectChanges();
      },
        (e) => { // Open the select even if it fails.
          this.sbSvcProvider.overlaySvc.enableOverlay();
          this.emailSelectOpen = true;
          this.contactEmailSvc.triggerRefresh();
          this.cd.detectChanges();
        });
  }

  confirmEmailSelect() {
    if (this.selectedEmails.some(e => e.emailMethod === EmailMethodEnum.TO)) {
      this.isGenerating = true;
      this.cd.detectChanges();
      //NEED TO CHECK ON SUBMIT AND EMAIL this.selectedSth,
      const emailInvoice$ = this.invoiceSvc.emailCustomerStatement(this.contactForStatement.uid, this.selectedEmails).pipe(share());//
      const notifier = this.createAsyncNotification(emailInvoice$);
      emailInvoice$.subscribe(() => {
        this.selectedEmails = [];
        this.isGenerating = false;
        this.cd.detectChanges();
        notifier.updateTitle('Success');
        notifier.updateContent('Invoice successfully approved & emailed');
      },
        (e) => {
          console.error(e);
          this.isGenerating = false;
          this.cd.detectChanges();
          notifier.updateTitle('Error');
          notifier.updateContent('Failed to approve & email invoice.');
        });
      this.sbSvcProvider.notificationSvc.postNotification(notifier);
      this.emailSelectOpen = false;
      this.sbSvcProvider.overlaySvc.disableOverlay();
    } else {
      this.sbSvcProvider.notificationSvc.postNotification(this.sbSvcProvider.notificationSvc.notificationBuilder('Warning',
        'A recipient must be marked with the "TO" Method.', StarbaseNotificationTypes.Warning));
    }
  }

  cancelEmailSelect() {
    this.selectedEmails = [];
    this.emailSelectOpen = false;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  selectEmail(email: STContactEmail) {
    if (email.selected) {
      this.selectedEmails = this.selectedEmails.filter(x => x.uid !== email.uid);
      this.selectedEmails.push(email);
    } else {
      this.selectedEmails = this.selectedEmails.filter(x => x.uid !== email.uid);
    }
  }

  openCustomerSelect() {
    var filterParam = new FilterParams<STContact>();
    const customerSearch$ = this.contactDashSvc.getCustomers().pipe(share());
    const notifier = this.createAsyncNotification(customerSearch$);
    customerSearch$.subscribe(
      f => {
        this.customerSelectItems = f;
        this.customerSelectOpen = true;
        this.sbSvcProvider.overlaySvc.enableOverlay();
        notifier.updateTitle('Completed');
      }
    );
  }

  closeCustomerSelect() {
    this.sbSvcProvider.overlaySvc.disableOverlay();
    this.customerSelectOpen = false;
    this.customerSelectItems = [];
  }

  finishCustomerSelect() {
    this.customerSelectItems = this.customerSelectItems.filter(x => x.selected);
    this.sbSvcProvider.overlaySvc.disableOverlay();
    this.customerSelectOpen = false;
    this.startEmailStatements();
  }

  startEmailStatements() {
    this.statementEmailerOpen = true;
    this.sbSvcProvider.overlaySvc.enableOverlay();
  }

  finishCustomerStatment() {
    this.statementEmailerOpen = false;
    this.sbSvcProvider.overlaySvc.disableOverlay();
  }

  selectAllCustomers(selectedCustomers: STContact[]) {
    this.customerSelectItems = selectedCustomers;
    this.customerSelectItems.forEach(x => x.selected = true);
    if (this.customerSelect) {
      this.customerSelect.refreshData(this.customerSelect.filter, this.contactDashSvc.customerBroadSearchUri);
    }
  }

  selectCustomer(customer: STContact) {
    if (customer === null) {
      this.customerSelectItems = [];
    } else if (customer.selected) {
      this.customerSelectItems.push(customer);
    } else {
      this.customerSelectItems = this.customerSelectItems.filter(x => x.contactUID !== customer.contactUID);
    }
  }
}
